// pa translations
export const PA_TRANSLATIONS: { [key: string]: string } = {

    "punjabiLanguageLabel": "ਪੰਜਾਬੀ",
    "--DropoffLateReason": "-- ਡ੍ਰੌਪਆਫ ਦੇਰ ਦਾ ਕਾਰਨ --",
    "--FundingSource--": "-- ਫੰਡਿੰਗ ਸਰੋਤ --",
    "--PickupLateReason": "--ਪਿਕਅਪ ਲੇਟ ਹੋਣ ਦਾ ਕਾਰਨ --",
    "--Seats--": "-- ਸੀਟਾਂ --",
    "--Select--": "-- ਚੁਣੋ --",
    "--SelectAccountStatus": "-- ਖਾਤਾ ਸਥਿਤੀ ਚੁਣੋ --",
    "--SelectAssist--": "-- ਅਸਿਸਟ ਚੁਣੋ --",
    "--SelectBodyType": "-- ਸਰੀਰ ਦੀ ਕਿਸਮ ਚੁਣੋ --",
    "--SelectBroker--": "-- ਬ੍ਰੋਕਰ ਚੁਣੋ --",
    "--SelectCancelReasons": "-- ਰੱਦ ਕਰਨ ਦੇ ਕਾਰਨ ਚੁਣੋ --",
    "--SelectCapacity--": "-- ਸਮਰੱਥਾ ਚੁਣੋ --",
    "--SelectCompetency--": "-- ਯੋਗਤਾ ਚੁਣੋ --",
    "--SelectCorporateUser": "-- ਕਾਰਪੋਰੇਟ ਉਪਭੋਗਤਾ ਚੁਣੋ --",
    "--SelectDateFormat": "-- ਮਿਤੀ ਫਾਰਮੈਟ ਚੁਣੋ --",
    "--SelectDay--": "-- ਦਿਨ ਚੁਣੋ --",
    "--SelectDiagnosismedicalCond": "-- ਡਾਇਗਨੋਸਿਸ/ਮੈਡੀਕਲ ਸਥਿਤੀ ਦੀ ਚੋਣ ਕਰੋ --",
    "--SelectDoModifier": "-- DO ਮੋਡੀਫਾਇਰ ਚੁਣੋ --",
    "--SelectDrivers--": "-- ਡਰਾਈਵਰ ਚੁਣੋ --",
    "--SelectDrivers--2": "-- ਡਰਾਈਵਰ ਚੁਣੋ --",
    "--SelectEmploymentType": "-- ਰੁਜ਼ਗਾਰ ਦੀ ਕਿਸਮ ਚੁਣੋ --",
    "--SelectEquipment--": "-- ਉਪਕਰਨ ਚੁਣੋ --",
    "--SelectFleet--": "-- ਫਲੀਟ ਚੁਣੋ --",
    "--SelectFs--": "-- FS ਚੁਣੋ --",
    "--SelectFuelType": "-- ਬਾਲਣ ਦੀ ਕਿਸਮ ਚੁਣੋ --",
    "--SelectGroup--": "-- ਸਮੂਹ ਚੁਣੋ --",
    "--SelectMapper--": "-- ਮੈਪਰ ਚੁਣੋ --",
    "--SelectMemberRole": "-- ਮੈਂਬਰ ਰੋਲ ਚੁਣੋ --",
    "--SelectMethod--": "-- ਵਿਧੀ ਚੁਣੋ --",
    "--SelectMonth--": "-- ਮਹੀਨਾ ਚੁਣੋ --",
    "--SelectOperationsManager": "-- ਓਪਰੇਸ਼ਨ ਮੈਨੇਜਰ ਦੀ ਚੋਣ ਕਰੋ --",
    "--SelectPlatformportal--": "-- ਪਲੇਟਫਾਰਮ/ਪੋਰਟਲ ਚੁਣੋ --",
    "--SelectPosition--": "-- ਸਥਿਤੀ ਚੁਣੋ --",
    "--SelectProficiency--": "-- ਮੁਹਾਰਤ ਦੀ ਚੋਣ ਕਰੋ --",
    "--SelectPuModifier": "-- PU ਮੋਡੀਫਾਇਰ ਚੁਣੋ --",
    "--SelectReason--": "-- ਕਾਰਨ ਚੁਣੋ --",
    "--SelectRoleType": "-- ਰੋਲ ਦੀ ਕਿਸਮ ਚੁਣੋ --",
    "--SelectServiceAreas": "-- ਸੇਵਾ ਖੇਤਰ ਚੁਣੋ --",
    "--SelectShiftAlign": "-- ਸ਼ਿਫਟ ਅਲਾਈਨ ਚੁਣੋ --",
    "--SelectSpacetype--": "-- ਸਪੇਸ ਟਾਈਪ ਚੁਣੋ --",
    "--SelectStateCode": "-- ਰਾਜ ਕੋਡ ਚੁਣੋ --",
    "--SelectStationManager": "-- ਸਟੇਸ਼ਨ ਮੈਨੇਜਰ ਦੀ ਚੋਣ ਕਰੋ --",
    "--SelectStatus--": "-- ਸਥਿਤੀ ਚੁਣੋ --",
    "--SelectStatuss--": "-- ਸਥਿਤੀ(ਆਂ) ਦੀ ਚੋਣ ਕਰੋ --",
    "--SelectTemplate--": "-- ਟੈਂਪਲੇਟ ਚੁਣੋ --",
    "--SelectTimeFormat": "-- ਟਾਈਮ ਫਾਰਮੈਟ ਚੁਣੋ --",
    "--SelectType--": "-- ਕਿਸਮ ਚੁਣੋ --",
    "--SelectVehicle--": "-- ਵਾਹਨ ਚੁਣੋ --",
    "--ServiceArea--": "-- ਸੇਵਾ ਖੇਤਰ --",
    "--SpaceType--": "-- ਸਪੇਸ ਦੀ ਕਿਸਮ --",
    "--selectRequiredOdometer--": "--ਲੋੜੀਂਦਾ ਓਡੋਮੀਟਰ ਚੁਣੋ--",
    "--selectStatus--": "--ਸਥਿਤੀ ਚੁਣੋ--",
    "-selectFundingSource-": "- ਫੰਡਿੰਗ ਸਰੋਤ ਚੁਣੋ-",
    "10min": "10 ਮਿੰਟ",
    "15min": "15 ਮਿੰਟ",
    "1HourViolation": "1 ਘੰਟੇ ਦੀ ਉਲੰਘਣਾ",
    "30min": "30 ਮਿੰਟ",
    "Amendments": "ਸੋਧਾਂ",
    "Announcement": "ਘੋਸ਼ਣਾ",
    "Cities Zones": "ਸ਼ਹਿਰਾਂ ਦੇ ਜ਼ੋਨ",
    "Companies": "ਕੰਪਨੀਆਂ",
    "Drivers": "ਡਰਾਈਵਰ",
    "Drivers Load": "ਡਰਾਈਵਰ ਲੋਡ",
    "Equipment Planning": "ਉਪਕਰਨ ਯੋਜਨਾ",
    "Equipments": "ਉਪਕਰਨ",
    "Funding Sources": "ਫੰਡਿੰਗ ਸਰੋਤ",
    "Holidays": "ਛੁੱਟੀਆਂ",
    "Late Forecast": "ਦੇਰ ਪੂਰਵ ਅਨੁਮਾਨ",
    "Late Reasons": "ਦੇਰ ਕਾਰਨ",
    "Level of Service": "ਸੇਵਾ ਦਾ ਪੱਧਰ",
    "Mapper": "ਮੈਪਰ",
    "Members": "ਮੈਂਬਰ",
    "Miles For Bucks": "ਬਕਸ ਲਈ ਮੀਲ",
    "New Trip": "ਨਵੀਂ ਯਾਤਰਾ",
    "Offered": "ਦੀ ਪੇਸ਼ਕਸ਼ ਕੀਤੀ",
    "Payors": "ਭੁਗਤਾਨ ਕਰਨ ਵਾਲੇ",
    "Profiling": "ਪ੍ਰੋਫਾਈਲਿੰਗ",
    "Quarters": "ਕੁਆਰਟਰ",
    "Schedule": "ਤਹਿ",
    "Service Areas": "ਸੇਵਾ ਖੇਤਰ",
    "Shift Override": "ਸ਼ਿਫਟ ਓਵਰਰਾਈਡ",
    "Space Type Checklist": "ਸਪੇਸ ਟਾਈਪ ਚੈੱਕਲਿਸਟ",
    "Space Types": "ਸਪੇਸ ਦੀਆਂ ਕਿਸਮਾਂ",
    "Staff": "ਸਟਾਫ਼",
    "Standing Orders": "ਸਟੈਂਡਿੰਗ ਆਰਡਰ",
    "Templates": "ਟੈਂਪਲੇਟਸ",
    "Timesheet": "ਟਾਈਮਸ਼ੀਟ",
    "Trip Sheet": "ਯਾਤਰਾ ਸ਼ੀਟ",
    "Vehicles": "ਵਾਹਨ",
    "Violations": "ਉਲੰਘਣਾਵਾਂ",
    "aaccountStatusIsRequired": "ਖਾਤੇ ਦੀ ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "accept": "ਸਵੀਕਾਰ ਕਰੋ",
    "accepted": "ਸਵੀਕਾਰ ਕਰ ਲਿਆ",
    "acceptedTrips": "ਸਵੀਕ੍ਰਿਤ ਯਾਤਰਾਵਾਂ",
    "accidentAndIncidentTraining": "ਦੁਰਘਟਨਾ ਅਤੇ ਘਟਨਾ ਦੀ ਸਿਖਲਾਈ",
    "accountStatus": "ਖਾਤਾ ਸਥਿਤੀ",
    "accountStatusIsRequired": "ਖਾਤਾ ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "acknowledgeByDriver": "ਡਰਾਈਵਰ ਦੁਆਰਾ ਮਾਨਤਾ",
    "act": "ਐਕਟ",
    "action": "ਕਾਰਵਾਈ",
    "actions": "ਕਾਰਵਾਈਆਂ",
    "actualShift": "ਅਸਲ ਸ਼ਿਫਟ",
    "add": "+ ਸ਼ਾਮਲ ਕਰੋ",
    "addAddon": "ਐਡੋਨ ਸ਼ਾਮਲ ਕਰੋ",
    "addAmendment": "ਸੋਧ ਸ਼ਾਮਲ ਕਰੋ",
    "addAnnouncement": "ਘੋਸ਼ਣਾ ਸ਼ਾਮਲ ਕਰੋ",
    "addAppointmentType": "ਮੁਲਾਕਾਤ ਦੀ ਕਿਸਮ ਸ਼ਾਮਲ ਕਰੋ",
    "addBeneficiary": "ਲਾਭਪਾਤਰੀ ਸ਼ਾਮਲ ਕਰੋ",
    "addBreak": "ਬਰੇਕ ਸ਼ਾਮਲ ਕਰੋ",
    "addBroker": "ਬ੍ਰੋਕਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addCancelReason": "ਰੱਦ ਕਰਨ ਦਾ ਕਾਰਨ ਸ਼ਾਮਲ ਕਰੋ",
    "addChecklist": "ਚੈੱਕਲਿਸਟ ਸ਼ਾਮਲ ਕਰੋ",
    "addCity": "ਸਿਟੀ ਸ਼ਾਮਲ ਕਰੋ",
    "addCompany": "ਕੰਪਨੀ ਸ਼ਾਮਲ ਕਰੋ",
    "addDistribution": "ਵੰਡ ਸ਼ਾਮਲ ਕਰੋ",
    "addDriver": "ਡਰਾਈਵਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addEquipment": "ਉਪਕਰਨ ਸ਼ਾਮਲ ਕਰੋ",
    "addFundingSource": "ਫੰਡਿੰਗ ਸਰੋਤ ਸ਼ਾਮਲ ਕਰੋ",
    "addHoliday": "ਛੁੱਟੀਆਂ ਸ਼ਾਮਲ ਕਰੋ",
    "addLegButton": "+ ਲੱਤ",
    "addLevelOfService": "ਸੇਵਾ ਦਾ ਪੱਧਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addMapper": "ਮੈਪਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addMember": "ਮੈਂਬਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addModifierCode": "ਸੋਧਕ ਕੋਡ ਸ਼ਾਮਲ ਕਰੋ",
    "addPayor": "ਪੇਅਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addPrimaryDiagnose": "ਪ੍ਰਾਇਮਰੀ ਨਿਦਾਨ ਸ਼ਾਮਲ ਕਰੋ",
    "addQuarter": "ਤਿਮਾਹੀ ਸ਼ਾਮਲ ਕਰੋ",
    "addRate": "ਦਰ ਜੋੜੋ",
    "addReason": "ਕਾਰਨ ਸ਼ਾਮਲ ਕਰੋ",
    "addServiceArea": "ਸੇਵਾ ਖੇਤਰ ਸ਼ਾਮਲ ਕਰੋ",
    "addShift": "ਸ਼ਿਫਟ ਸ਼ਾਮਲ ਕਰੋ",
    "addShiftOverride": "ਸ਼ਿਫਟ ਓਵਰਰਾਈਡ ਸ਼ਾਮਲ ਕਰੋ",
    "addSpaceType": "ਸਪੇਸ ਦੀ ਕਿਸਮ ਸ਼ਾਮਲ ਕਰੋ",
    "addStaff": "ਸਟਾਫ ਸ਼ਾਮਲ ਕਰੋ",
    "addTemplate": "ਟੈਮਪਲੇਟ ਸ਼ਾਮਲ ਕਰੋ",
    "addTips": "ਸੁਝਾਅ ਸ਼ਾਮਲ ਕਰੋ",
    "addTripHeader": "ਸ਼ਾਮਲ ਕਰੋ",
    "addVehicle": "ਵਾਹਨ ਸ਼ਾਮਲ ਕਰੋ",
    "addYourComment": "ਆਪਣੀ ਟਿੱਪਣੀ ਸ਼ਾਮਲ ਕਰੋ",
    "addYourComment2": "ਆਪਣੀ ਟਿੱਪਣੀ ਸ਼ਾਮਲ ਕਰੋ...",
    "addZone": "ਜ਼ੋਨ ਸ਼ਾਮਲ ਕਰੋ",
    "additionalInformation": "ਵਧੀਕ ਜਾਣਕਾਰੀ",
    "additionalNote": "ਵਧੀਕ ਨੋਟ",
    "addonButton": "+ ਐਡੋਨ",
    "addonItemLabel": "ਆਈਟਮ",
    "addonItemRequired": "ਆਈਟਮ ਦੀ ਲੋੜ ਹੈ",
    "addonServicesHeader": "ਐਡਨ ਸੇਵਾਵਾਂ",
    "address": "ਪਤਾ:",
    "addressLabel": "ਪਤਾ",
    "addressName": "ਪਤਾ ਨਾਮ",
    "addressNameIsRequired": "ਪਤਾ ਨਾਮ ਦੀ ਲੋੜ ਹੈ",
    "addressRequired": "ਪਤਾ ਲੋੜੀਂਦਾ ਹੈ",
    "addressValidationAlert": "ਪਤਾ ਪ੍ਰਮਾਣਿਕਤਾ ਚੇਤਾਵਨੀ",
    "addupdateSignature": "ਦਸਤਖਤ ਜੋੜੋ/ਅੱਪਡੇਟ ਕਰੋ",
    "adjustTrip": "ਯਾਤਰਾ ਨੂੰ ਵਿਵਸਥਿਤ ਕਰੋ",
    "adjustment": "ਸਮਾਯੋਜਨ",
    "adlAmbulanceDriversLicense": "ADL (ਐਂਬੂਲੈਂਸ ਡਰਾਈਵਰ ਲਾਇਸੈਂਸ)",
    "adlImageIsRequired": "ADL ਚਿੱਤਰ ਦੀ ਲੋੜ ਹੈ",
    "admin": "ਐਡਮਿਨ",
    "agent": "ਏਜੰਟ",
    "alarming": "ਚਿੰਤਾਜਨਕ",
    "alarmingTrips": "ਚਿੰਤਾਜਨਕ ਯਾਤਰਾਵਾਂ",
    "alcReminder": "ALC ਰੀਮਾਈਂਡਰ",
    "alcoholScreeningRecentScreen": "ਅਲਕੋਹਲ ਸਕ੍ਰੀਨਿੰਗ (ਹਾਲੀਆ ਸਕ੍ਰੀਨਿੰਗ)",
    "algorithm": "ਐਲਗੋਰਿਦਮ",
    "all": "ਸਾਰੇ",
    "allDrivers": "ਸਾਰੇ ਡਰਾਈਵਰ",
    "allMessages": "ਸਾਰੇ ਸੁਨੇਹੇ",
    "allNotifications": "ਸਾਰੀਆਂ ਸੂਚਨਾਵਾਂ",
    "allowAttendee": "ਹਾਜ਼ਰ ਹੋਣ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ",
    "allowAuthorizationNumberFor": "ਇੱਕ ਕੇਅਰ ਲਈ ਪ੍ਰਮਾਣਿਕਤਾ ਨੰਬਰ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowPlacement": "ਪਲੇਸਮੈਂਟ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowCamera": "ਕੈਮਰੇ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ",
    "allowCapacityViolation": "ਸਮਰੱਥਾ ਦੀ ਉਲੰਘਣਾ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowCapacityViolations": "ਸਮਰੱਥਾ ਦੀ ਉਲੰਘਣਾ(ਆਂ) ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowIncentive": "ਪ੍ਰੋਤਸਾਹਨ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ",
    "allowIpcr": "IPCR ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowAuditLogs": "ਆਡਿਟ ਲੌਗਸ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowCoverage": "ਕਵਰੇਜ ਦੀ ਆਗਿਆ ਦਿਓ",
    "auditlogs": "ਆਡਿਟ ਲੌਗਸ",
    "allowMulti-factorAuthenticat": "ਮਲਟੀ-ਫੈਕਟਰ ਪ੍ਰਮਾਣਿਕਤਾ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowNearBy": "ਨੇੜੇ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ",
    "allowOnboardViolations": "ਆਨਬੋਰਡ ਉਲੰਘਣਾ(ਲਾਂ) ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowPossibility": "ਸੰਭਾਵਨਾ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowSms": "ਐਸਐਮਐਸ ਦੀ ਆਗਿਆ ਦਿਓ",
    "allowTimesheet": "ਟਾਈਮਸ਼ੀਟ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ",
    "allowVoiceAssistance": "ਵੌਇਸ ਸਹਾਇਤਾ ਦੀ ਆਗਿਆ ਦਿਓ",
    "ambulance": "ਐਂਬੂਲੈਂਸ",
    "ambulette": "ਐਂਬੂਲੇਟ",
    "amendment": "ਸੋਧ",
    "amountIsRequired": "ਰਕਮ ਦੀ ਲੋੜ ਹੈ",
    "announcements": "ਘੋਸ਼ਣਾਵਾਂ",
    "api": "API",
    "appealed": "ਅਪੀਲ ਕੀਤੀ",
    "appky": "ਐਪਕੀ",
    "applyIncentive": "ਪ੍ਰੋਤਸਾਹਨ ਲਾਗੂ ਕਰੋ",
    "appointmentDirectionInside": "ਕੇਂਦਰ ਦੇ ਅੰਦਰ",
    "appointmentDirectionLabel": "ਨਿਯੁਕਤੀ ਨਿਰਦੇਸ਼",
    "appointmentDirectionOutside": "ਕੇਂਦਰ ਦੇ ਬਾਹਰ",
    "appointmentTime": "ਮੁਲਾਕਾਤ ਦਾ ਸਮਾਂ",
    "appointmentTimeIsRequired": "ਮੁਲਾਕਾਤ ਦਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "appointmentTypeLabel": "ਮੁਲਾਕਾਤ ਦੀ ਕਿਸਮ",
    "appointmentTypeRequired": "ਮੁਲਾਕਾਤ ਦੀ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "appointmentTypefileIsRequire": "ਨਿਯੁਕਤੀ ਦੀ ਕਿਸਮ (ਫਾਈਲ) ਦੀ ਲੋੜ ਹੈ",
    "appointmentTypetpIsRequired": "ਨਿਯੁਕਤੀ ਦੀ ਕਿਸਮ (TP) ਦੀ ਲੋੜ ਹੈ",
    "approachingAlert": "ਨੇੜੇ ਆਉਣ ਦੀ ਚੇਤਾਵਨੀ",
    "approachingTrips": "ਨੇੜੇ ਆਉਣ ਵਾਲੀਆਂ ਯਾਤਰਾਵਾਂ",
    "approve": "ਮਨਜ਼ੂਰ ਕਰੋ",
    "approved": "ਨੂੰ ਮਨਜ਼ੂਰੀ ਦਿੱਤੀ",
    "aptOrSuiteIs": "APT ਜਾਂ ਸੂਟ ਦੀ ਲੋੜ ਹੈ",
    "aptOrSuiteLabel": "APT/ਸੂਟ",
    "aptOrSuiteRequired": "APT/SUITE ਦੀ ਲੋੜ ਹੈ",
    "aptsuiteroom": "ਅਪਾਰਟ/ਸੂਟ/ਕਮਰਾ",
    "arabicLanguageLabel": "ਅਰਬੀ",
    "archive": "ਪੁਰਾਲੇਖ",
    "archived": "ਪੁਰਾਲੇਖ",
    "archivedTrips": "ਆਰਕਾਈਵ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "areYouSureYou": "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਇਸ ਯਾਤਰਾ ਨੂੰ ਇੱਕ ਨਵੇਂ ਸਮੇਂ ਵਿੱਚ ਤਬਦੀਲ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "areYouSureYou2": "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਰੱਦ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "areYouSureYou3": "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਓਡੋਮੀਟਰ ਨੂੰ ਅੱਪਡੇਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "areYouSureYou4": "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਇਸ ਖਾਸ ਮਿਤੀ 'ਤੇ ਮਾਤਾ-ਪਿਤਾ ਦੇ ਸਟੈਂਡਿੰਗ ਆਰਡਰ ਤੋਂ ਯਾਤਰਾ ਬਣਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    "areYouSureYou5": "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਸਿਸਟਮ ਤੋਂ ਸਾਰੇ ਯਾਤਰਾਵਾਂ ਦੇ ਡੇਟਾ ਨੂੰ ਸਵੀਪ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ। ਤੁਹਾਨੂੰ ਡ੍ਰਾਈਵਰ ਨੂੰ ਕੋਈ ਵੀ ਯਾਤਰਾ ਨਿਰਧਾਰਤ ਕਰਨ ਲਈ ਦੁਬਾਰਾ ਡੇਟਾ ਨੂੰ ਮੁੜ-ਆਯਾਤ ਕਰਨਾ ਪਵੇਗਾ ਕਿਉਂਕਿ ਇਹ ਇੱਕ ਸਥਾਈ ਕਾਰਵਾਈ ਹੈ?",
    "arn": "ਏ.ਆਰ.ਐਨ",
    "arrears": "ਬਕਾਏ",
    "arrearsLabel": "ਬਕਾਏ ਲੇਬਲ",
    "arrived": "ਪਹੁੰਚੇ",
    "assign": "ਅਸਾਈਨ ਕਰੋ",
    "assignTrip": "ਯਾਤਰਾ ਨਿਰਧਾਰਤ ਕਰੋ",
    "assignMultipleTrips": "ਕਈ ਯਾਤਰਾਵਾਂ ਨਿਰਧਾਰਤ ਕਰੋ",
    "assignVehicle": "ਵਾਹਨ ਨਿਰਧਾਰਤ ਕਰੋ",
    "assignedTrips": "ਸਪੁਰਦ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "assist": "ਸਹਾਇਤਾ",
    "assistShiftAlign": "ਅਸਿਸਟ ਸ਼ਿਫਟ ਅਲਾਈਨ",
    "assistShiftAlignIs": "ਅਸਿਸਟ ਸ਼ਿਫਟ ਅਲਾਈਨ ਦੀ ਲੋੜ ਹੈ",
    "assistShiftDayWise": "ਅਸਿਸਟ ਸ਼ਿਫਟ (ਦਿਨ ਅਨੁਸਾਰ)",
    "assistShiftEnd": "ਅਸਿਸਟ ਸ਼ਿਫਟ ਐਂਡ",
    "assistShiftEndIs": "ਅਸਿਸਟ ਸ਼ਿਫਟ ਐਂਡ ਦੀ ਲੋੜ ਹੈ",
    "assistShiftStart": "ਅਸਿਸਟ ਸ਼ਿਫਟ ਸਟਾਰਟ",
    "assistShiftStartIs": "ਅਸਿਸਟ ਸ਼ਿਫਟ ਸਟਾਰਟ ਦੀ ਲੋੜ ਹੈ",
    "assistsLabel": "ਸਹਾਇਤਾ ਕਰਦਾ ਹੈ",
    "associateImage": "ਐਸੋਸੀਏਟ ਚਿੱਤਰ",
    "atLeastOneAssist": "ਘੱਟੋ-ਘੱਟ ਇੱਕ ਸਹਾਇਕ ਸ਼ਿਫਟ ਦੀ ਲੋੜ ਹੈ",
    "atleastOneDayShift": "ਘੱਟੋ-ਘੱਟ ਇੱਕ ਦਿਨ ਦੀ ਸ਼ਿਫਟ ਦੀ ਲੋੜ ਹੈ",
    "atleastOneDriverIs": "ਘੱਟੋ-ਘੱਟ ਇੱਕ ਡਰਾਈਵਰ ਦੀ ਲੋੜ ਹੈ",
    "attachPdfButton": "PDF ਨੱਥੀ ਕਰੋ",
    "attchedPdf": "ਨੱਥੀ ਪੀ.ਡੀ.ਐਫ",
    "authNumberLabel": "ਪ੍ਰਮਾਣਿਕਤਾ ਨੰਬਰ",
    "authorizationNumberIsRequire": "ਪ੍ਰਮਾਣਿਕਤਾ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "authorizer": "ਅਧਿਕਾਰਕ",
    "autoAssignWillCall": "ਆਟੋ ਅਸਾਈਨ ਕਾਲ ਕਰੇਗਾ",
    "autoGenerate": "ਆਟੋ ਜਨਰੇਟ ਕਰੋ",
    "autoRefresh": "ਆਟੋ ਰਿਫ੍ਰੈਸ਼",
    "autoTimeStamp": "ਆਟੋ ਟਾਈਮ ਸਟੈਂਪ",
    "autoTimestamp": "ਆਟੋ ਟਾਈਮਸਟੈਂਪ",
    "autoZoom": "ਆਟੋ ਜ਼ੂਮ",
    "available": "ਉਪਲਬਧ ਹੈ",
    "avatar": "ਅਵਤਾਰ",
    "backToLogin": "ਲੌਗਇਨ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    "background": "ਪਿਛੋਕੜ",
    "badPhonenumber": "ਖਰਾਬ ਫ਼ੋਨ ਨੰਬਰ",
    "banked": "ਬੈਂਕ ਕੀਤਾ",
    "baseFare": "ਬੇਸ ਕਿਰਾਇਆ",
    "baseFareCode": "ਬੇਸ ਫੇਅਰ ਕੋਡ",
    "baseFareCodeIs": "ਬੇਸ ਫੇਅਰ ਕੋਡ ਦੀ ਲੋੜ ਹੈ",
    "baseFareFor": "ਲਈ ਬੇਸ ਕਿਰਾਇਆ",
    "baseFareForIs": "ਲਈ ਬੇਸ ਕਿਰਾਇਆ ਲੋੜੀਂਦਾ ਹੈ",
    "baseFareIsRequired": "ਬੇਸ ਕਿਰਾਇਆ ਲੋੜੀਂਦਾ ਹੈ",
    "batch": "ਬੈਚ",
    "bedBugProtocol": "ਬੈੱਡ ਬੱਗ ਪ੍ਰੋਟੋਕੋਲ",
    "bedLengthIsRequired": "ਬੈੱਡ ਦੀ ਲੰਬਾਈ ਦੀ ਲੋੜ ਹੈ",
    "beginAt": "ਇੱਥੇ ਸ਼ੁਰੂ ਕਰੋ:",
    "billTo": "ਬਿਲ ਨੂੰ *",
    "billerNote": "ਬਿਲਰ ਨੋਟ",
    "billerNotes": "ਬਿਲਰ ਨੋਟਸ",
    "billing": "ਬਿਲਿੰਗ",
    "bloodbornePathogenTrainingEx": "ਖੂਨ ਨਾਲ ਪੈਦਾ ਹੋਣ ਵਾਲੇ ਰੋਗਾਣੂ ਸਿਖਲਾਈ (EXP)",
    "bloodbornePathogens": "ਖੂਨ ਦੇ ਜਰਾਸੀਮ",
    "bodyType": "ਸਰੀਰ ਦੀ ਕਿਸਮ",
    "bodyTypeIsRequired": "ਸਰੀਰ ਦੀ ਕਿਸਮ ਲੋੜੀਂਦੀ ਹੈ",
    "both": "ਦੋਵੇਂ",
    "break": "ਤੋੜਨਾ",
    "breakCushion": "ਬਰੇਕ ਕੁਸ਼ਨ:",
    "breakFinished": "ਬਰੇਕ (ਮੁਕੰਮਲ)",
    "breakScheduled": "ਬਰੇਕ (ਅਨੁਸੂਚਿਤ)",
    "breaks": "ਤੋੜਦਾ ਹੈ",
    "broker-img": "ਬ੍ਰੋਕਰ-img",
    "brokerConfiguration": "ਬ੍ਰੋਕਰ ਕੌਂਫਿਗਰੇਸ਼ਨ",
    "brokerId": "ਬ੍ਰੋਕਰ ਆਈ.ਡੀ",
    "brokerIsRequired": "ਬ੍ਰੋਕਰ ਦੀ ਲੋੜ ਹੈ",
    "bsr": "ਬੀ.ਐੱਸ.ਆਰ",
    "bsr2": "BSR:",
    "bulkConfirmation": "ਬਲਕ ਪੁਸ਼ਟੀ",
    "businessNumber": "ਕਾਰੋਬਾਰੀ ਨੰਬਰ",
    "businessNumberIsRequired": "ਕਾਰੋਬਾਰੀ ਨੰਬਰ ਲੋੜੀਂਦਾ ਹੈ",
    "businessReport": "ਕਾਰੋਬਾਰੀ ਰਿਪੋਰਟ",
    "businessReports": "ਕਾਰੋਬਾਰੀ ਰਿਪੋਰਟਾਂ",
    "busy": "ਵਿਅਸਤ",
    "bySavingTheInformation": "ਇਸ ਫਾਰਮ ਵਿੱਚ ਜਾਣਕਾਰੀ ਨੂੰ ਰੱਖਿਅਤ ਕਰਕੇ, ਤੁਸੀਂ ਸੰਸਥਾ ਦੇ ਅਧਿਕਾਰਤ ਪ੍ਰਤੀਨਿਧੀ ਦੇ ਤੌਰ 'ਤੇ ਇਸ ਗੱਲ ਦੀ ਤਸਦੀਕ ਕਰਦੇ ਹੋ ਕਿ ਇਹ ਜਾਣਕਾਰੀ ਉਸ ਦੁਆਰਾ ਕੀਤੇ ਗਏ ਟ੍ਰਾਂਸਪੋਰਟਾਂ ਨੂੰ ਸਹੀ ਰੂਪ ਵਿੱਚ ਦਰਸਾਉਂਦੀ ਹੈ। ਤੁਸੀਂ ਇਸ ਦੁਆਰਾ ਪ੍ਰਮਾਣਿਤ ਕਰਦੇ ਹੋ ਕਿ ਇਹ ਜਾਣਕਾਰੀ ਤੁਹਾਡੀ ਸਭ ਤੋਂ ਉੱਤਮ ਜਾਣਕਾਰੀ ਅਨੁਸਾਰ ਸੱਚੀ, ਸਟੀਕ ਅਤੇ ਸੰਪੂਰਨ ਹੈ ਅਤੇ ਤੁਸੀਂ ਸਮਝਦੇ ਹੋ ਕਿ ਭੌਤਿਕ ਤੱਥਾਂ ਨੂੰ ਕਿਸੇ ਵੀ ਤਰ੍ਹਾਂ ਦਾ ਝੂਠਾ, ਭੁੱਲ ਜਾਂ ਛੁਪਾਉਣਾ ਤੁਹਾਡੇ ਅਤੇ/ਜਾਂ ਸੰਸਥਾ ਨੂੰ ਇਕਰਾਰਨਾਮੇ, ਪ੍ਰਬੰਧਕੀ, ਸਿਵਲ ਜਾਂ ਅਪਰਾਧਿਕ ਦੇਣਦਾਰੀ ਦੇ ਅਧੀਨ ਕਰ ਸਕਦਾ ਹੈ। ਤੁਸੀਂ ਇਹ ਵੀ ਸਮਝਦੇ ਹੋ ਕਿ ਇਹਨਾਂ ਟ੍ਰਾਂਸਪੋਰਟਾਂ ਲਈ ਸਾਰੇ ਦਸਤਾਵੇਜ਼ ਸਬੰਧਤ ਬੀਮਾ ਦਲਾਲਾਂ ਅਤੇ ਉਹਨਾਂ ਦੇ ਸਹਿਯੋਗੀਆਂ ਦੀਆਂ ਰਿਕਾਰਡ ਰੱਖ-ਰਖਾਅ ਨੀਤੀਆਂ ਦੇ ਅਨੁਸਾਰ ਬਣਾਏ ਜਾਣੇ ਹਨ।",
    "caTimesheet": "CA ਟਾਈਮਸ਼ੀਟ",
    "calculateButton": "ਗਣਨਾ ਕਰੋ",
    "calculateLocalMiles": "ਸਥਾਨਕ ਮੀਲਾਂ ਦੀ ਗਣਨਾ ਕਰੋ",
    "call": "ਕਾਲ ਕਰੋ",
    "callMemberToVerify": "ਰੱਦ ਕਰਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਮੈਂਬਰ ਨੂੰ ਕਾਲ ਕਰੋ",
    "cancel": "ਰੱਦ ਕਰੋ",
    "cancelCharges": "ਖਰਚੇ ਰੱਦ ਕਰੋ",
    "cancelChargesIsRequired": "ਖਰਚੇ ਰੱਦ ਕਰਨ ਦੀ ਲੋੜ ਹੈ",
    "cancelReason": "ਕਾਰਨ ਰੱਦ ਕਰੋ",
    "cancelReasons": "ਕਾਰਨ ਰੱਦ ਕਰੋ",
    "cancelReasonsIsRequired": "ਰੱਦ ਕਰਨ ਦੇ ਕਾਰਨਾਂ ਦੀ ਲੋੜ ਹੈ",
    "cancelTrip": "ਯਾਤਰਾ ਰੱਦ ਕਰੋ",
    "canceled": "ਰੱਦ ਕਰ ਦਿੱਤਾ",
    "cancellationNotes": "ਰੱਦ ਕਰਨ ਦੇ ਨੋਟਸ",
    "cancelled": "ਰੱਦ ਕਰ ਦਿੱਤਾ",
    "cancelledAt": "ਇਸ ਸਮੇਂ ਰੱਦ ਕੀਤਾ ਗਿਆ:",
    "cancelledFee": "ਰੱਦ ਕੀਤੀ ਫੀਸ *",
    "cancelledTripsSection": "ਰੱਦ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ ਸੈਕਸ਼ਨ",
    "capacities": "ਸਮਰੱਥਾਵਾਂ",
    "capacity": "ਸਮਰੱਥਾ",
    "capacityIsRequired": "ਸਮਰੱਥਾ ਦੀ ਲੋੜ ਹੈ",
    "careGiverInformation": "ਦੇਖਭਾਲ ਦੇਣ ਵਾਲੇ ਦੀ ਜਾਣਕਾਰੀ",
    "caregiverDetailsAreRequired": "ਦੇਖਭਾਲ ਕਰਨ ਵਾਲੇ ਦੇ ਵੇਰਵੇ ਲੋੜੀਂਦੇ ਹਨ",
    "centeneAttestationIss": "ਸੈਂਟੀਨ ਅਟੈਸਟੇਸ਼ਨ (ISS)",
    "certificateOfCompletionOnlok": "ਮੁਕੰਮਲ ਹੋਣ ਦਾ ਸਰਟੀਫਿਕੇਟ (ONLOK)",
    "certificationIsRequired": "ਸਰਟੀਫਿਕੇਸ਼ਨ ਦੀ ਲੋੜ ਹੈ",
    "certifiedMechanicVerificatio": "ਪ੍ਰਮਾਣਿਤ ਮਕੈਨਿਕ ਪੁਸ਼ਟੀਕਰਨ",
    "cf": "CF:",
    "change": "ਬਦਲੋ",
    "changePassword": "ਪਾਸਵਰਡ ਬਦਲੋ",
    "checkin": "ਚੈੱਕਇਨ",
    "checklist": "ਚੈੱਕਲਿਸਟ",
    "checklistIsRequired": "ਚੈੱਕਲਿਸਟ ਦੀ ਲੋੜ ਹੈ",
    "checklistNameIsRequired": "ਚੈੱਕਲਿਸਟ ਨਾਮ ਦੀ ਲੋੜ ਹੈ",
    "checkout": "ਚੈੱਕਆਉਟ",
    "chineseLanguageLabel": "ਚੀਨੀ",
    "city": "ਸ਼ਹਿਰ",
    "cityIsRequired": "ਸ਼ਹਿਰ ਦੀ ਲੋੜ ਹੈ",
    "citystate": "ਸ਼ਹਿਰ/ਰਾਜ",
    "claim": "ਦਾਅਵਾ",
    "claim2": "+ ਦਾਅਵਾ",
    "claimIsRequired": "ਦਾਅਵਾ ਲੋੜੀਂਦਾ ਹੈ",
    "claims": "ਦਾਅਵੇ",
    "clear": "ਸਾਫ਼",
    "clearVehicle": "ਸਾਫ਼ ਵਾਹਨ",
    "clientIdLabel": "ਕਲਾਇੰਟ ID / ਮੈਂਬਰ ID / MA# / AHCCCS#",
    "clientIdRequired": "ਕਲਾਇੰਟ ID / ਮੈਂਬਰ ID / MA# / AHCCCS# ਦੀ ਲੋੜ ਹੈ",
    "clone": "ਕਲੋਨ",
    "close": "ਬੰਦ ਕਰੋ",
    "closePanel": "ਪੈਨਲ ਬੰਦ ਕਰੋ",
    "closeSidebar": "ਸਾਈਡਬਾਰ ਬੰਦ ਕਰੋ",
    "closer": "ਨੇੜੇ",
    "cms1500": "CMS 1500",
    "code": "ਕੋਡ",
    "codeIsRequired": "ਕੋਡ ਲੋੜੀਂਦਾ ਹੈ",
    "color": "ਰੰਗ",
    "colorIsRequired": "ਰੰਗ ਦੀ ਲੋੜ ਹੈ",
    "comment": "ਟਿੱਪਣੀ",
    "commentIsRequired": "ਟਿੱਪਣੀ ਦੀ ਲੋੜ ਹੈ",
    "comments": "ਟਿੱਪਣੀਆਂ",
    "companiesStats": "ਕੰਪਨੀਆਂ ਦੇ ਅੰਕੜੇ",
    "company-img": "ਕੰਪਨੀ-img",
    "companyAlias": "ਕੰਪਨੀ ਉਪਨਾਮ *",
    "companyBillingName": "ਕੰਪਨੀ ਬਿਲਿੰਗ ਦਾ ਨਾਮ",
    "companyFaxNumber": "ਕੰਪਨੀ ਦਾ ਫੈਕਸ ਨੰਬਰ",
    "companyImage": "ਕੰਪਨੀ ਚਿੱਤਰ",
    "companyImageIsRequired": "ਕੰਪਨੀ ਚਿੱਤਰ ਦੀ ਲੋੜ ਹੈ",
    "companyInTake": "ਕੰਪਨੀ ਇਨ ਟੇਕ (%)",
    "companyInTakeIs": "ਕੰਪਨੀ ਇਨ ਟੇਕ ਦੀ ਲੋੜ ਹੈ",
    "companyMobileNumber": "ਕੰਪਨੀ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ",
    "companyMobileNumberIs": "ਕੰਪਨੀ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ ਲੋੜੀਂਦਾ ਹੈ",
    "companyName": "ਕੰਪਨੀ ਦਾ ਨਾਮ",
    "companyNameIsRequired": "ਕੰਪਨੀ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "companyNotes": "ਕੰਪਨੀ ਨੋਟਸ",
    "companyPhoto": "ਕੰਪਨੀ ਦੀ ਫੋਟੋ",
    "competency": "ਯੋਗਤਾ",
    "competencyIsRequired": "ਯੋਗਤਾ ਦੀ ਲੋੜ ਹੈ",
    "completed": "ਪੂਰਾ ਹੋਇਆ",
    "completedFee": "ਪੂਰੀ ਫੀਸ *",
    "completedTimeIsRequired": "ਪੂਰਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "compliancePlanTrainingFraud": "ਪਾਲਣਾ ਯੋਜਨਾ ਸਿਖਲਾਈ (ਧੋਖਾਧੜੀ, ਬਰਬਾਦੀ, ਅਤੇ ਦੁਰਵਿਵਹਾਰ) (ਆਚਾਰ ਸੰਹਿਤਾ)",
    "configurations": "ਸੰਰਚਨਾਵਾਂ",
    "confirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
    "confirmNewPassword": "ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    "confirmPassword": "ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    "confirmPasswordDidtMatch": "ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਪਾਸਵਰਡ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ",
    "confirmPasswordIsRequired": "ਪੁਸ਼ਟੀ ਪਾਸਵਰਡ ਲੋੜੀਂਦਾ ਹੈ",
    "confirmationReport": "ਪੁਸ਼ਟੀਕਰਣ ਰਿਪੋਰਟ",
    "confirmationText": "ਪੁਸ਼ਟੀਕਰਨ ਟੈਕਸਟ",
    "confirmedLabel": "ਪੁਸ਼ਟੀ ਕੀਤੀ",
    "contactNumber": "ਸੰਪਰਕ ਨੰਬਰ",
    "contactNumberIsRequired": "ਸੰਪਰਕ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "contractSent": "ਇਕਰਾਰਨਾਮਾ ਭੇਜਿਆ ਗਿਆ",
    "corporate": "ਕਾਰਪੋਰੇਟ",
    "corporateOdometerRequired": "ਕਾਰਪੋਰੇਟ ਓਡੋਮੀਟਰ ਦੀ ਲੋੜ ਹੈ",
    "corporatePrivatePay": "ਕਾਰਪੋਰੇਟ/ਪ੍ਰਾਈਵੇਟ ਤਨਖਾਹ",
    "costCenter": "ਲਾਗਤ ਕੇਂਦਰ",
    "costCenterIsRequired": "ਲਾਗਤ ਕੇਂਦਰ ਦੀ ਲੋੜ ਹੈ",
    "coverImage": "ਕਵਰ ਚਿੱਤਰ",
    "covid": "ਕੋਵਿਡ",
    "covid-19Vaccine": "ਕੋਵਿਡ-19 ਵੈਕਸੀਨ",
    "covid-19VaccineDeclined": "COVID-19 ਵੈਕਸੀਨ ਅਸਵੀਕਾਰ ਕੀਤੀ ਗਈ",
    "cprFirstAidCertification": "CPR / ਫਸਟ ਏਡ ਸਰਟੀਫਿਕੇਸ਼ਨ ਦੀ ਸ਼ੁਰੂਆਤੀ ਮਿਤੀ (EXP)",
    "cprFirstAidCertification2": "CPR / ਫਸਟ ਏਡ ਸਰਟੀਫਿਕੇਸ਼ਨ ਦੀ ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ (EXP)",
    "createBucket": "ਬਾਲਟੀ ਬਣਾਓ",
    "createButton": "ਬਣਾਓ",
    "createSchedule": "ਸਮਾਂ-ਸਾਰਣੀ ਬਣਾਓ",
    "createTrip": "ਯਾਤਰਾ ਬਣਾਓ",
    "createTripsManually": "ਹੱਥੀਂ ਯਾਤਰਾਵਾਂ ਬਣਾਓ",
    "created": "ਬਣਾਇਆ",
    "createdTimeIsRequired": "ਬਣਾਉਣ ਦਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "credentialInformation": "ਕ੍ਰੈਡੈਂਸ਼ੀਅਲ ਜਾਣਕਾਰੀ",
    "credentialing": "ਪ੍ਰਮਾਣੀਕਰਨ",
    "credentials": "ਪ੍ਰਮਾਣ-ਪੱਤਰ",
    "criminalBackgroundCheck": "ਅਪਰਾਧਿਕ ਪਿਛੋਕੜ ਦੀ ਜਾਂਚ",
    "criminalRecordAlcoholOr": "ਅਪਰਾਧਿਕ ਰਿਕਾਰਡ (ਸ਼ਰਾਬ ਜਾਂ ਨਸ਼ੀਲੇ ਪਦਾਰਥਾਂ ਦੀ ਦੁਰਵਰਤੋਂ)",
    "ctc": "CTC",
    "ctcBot": "CTC BOT",
    "ctcInvoice": "CTC ਇਨਵੌਇਸ",
    "ctcMarketplace": "ਸੀਟੀਸੀ ਮਾਰਕੀਟਪਲੇਸ",
    "ctcTrips": "CTC ਯਾਤਰਾਵਾਂ",
    "currentMeter": "ਮੌਜੂਦਾ ਮੀਟਰ",
    "currentMileageIsRequired": "ਮੌਜੂਦਾ ਮਾਈਲੇਜ ਦੀ ਲੋੜ ਹੈ",
    "currentPassword": "ਮੌਜੂਦਾ ਪਾਸਵਰਡ",
    "currentPasswordIsRequired": "ਮੌਜੂਦਾ ਪਾਸਵਰਡ ਲੋੜੀਂਦਾ ਹੈ",
    "custom": "ਕਸਟਮ",
    "daily": "ਰੋਜ਼ਾਨਾ",
    "dashboard": "ਡੈਸ਼ਬੋਰਡ",
    "date": "ਮਿਤੀ",
    "dateFormat": "ਮਿਤੀ ਫਾਰਮੈਟ",
    "dateFormatIsRequired": "ਮਿਤੀ ਫਾਰਮੈਟ ਲੋੜੀਂਦਾ ਹੈ",
    "dateIsRequired": "ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "dateOfInspection": "ਨਿਰੀਖਣ ਦੀ ਮਿਤੀ",
    "dateOfInspectionIs": "ਨਿਰੀਖਣ ਦੀ ਮਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "dateOfService": "ਸੇਵਾ ਦੀ ਮਿਤੀ",
    "dateRange": "ਮਿਤੀ ਰੇਂਜ *",
    "dayRequired": "ਦਿਨ ਦੀ ਲੋੜ ਹੈ",
    "days": "ਦਿਨ",
    "days2": "ਦਿਨ(ਦਿਨ)",
    "daysIsRequired": "ਦਿਨ ਲੋੜੀਂਦੇ ਹਨ",
    "ddmmyyyy": "DD/MM/YYYY",
    "deadMiles": "ਡੈੱਡ ਮੀਲਜ਼",
    "deadMilesRateIs": "ਡੈੱਡ ਮੀਲ ਰੇਟ ਦੀ ਲੋੜ ਹੈ",
    "deadheadTimeToPickup": "ਡੈੱਡਹੈੱਡ ਟਾਈਮ (ਪਿਕਅੱਪ ਕਰਨ ਲਈ)",
    "decline": "ਅਸਵੀਕਾਰ ਕਰੋ",
    "defensiveDrivingCourse": "ਰੱਖਿਆਤਮਕ ਡਰਾਈਵਿੰਗ ਕੋਰਸ",
    "delete": "ਮਿਟਾਓ",
    "deleteAll": "ਸਭ ਮਿਟਾਓ",
    "demo": "ਡੈਮੋ",
    "description": "ਵਰਣਨ",
    "descriptionIsRequired": "ਵਰਣਨ ਲੋੜੀਂਦਾ ਹੈ",
    "detail": "ਵੇਰਵੇ",
    "details": "ਵੇਰਵੇ",
    "diagnosismedicalCondition": "ਨਿਦਾਨ/ਮੈਡੀਕਲ ਸਥਿਤੀ",
    "diagnosismedicalConditionIsR": "ਨਿਦਾਨ/ਮੈਡੀਕਲ ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "dimensions": "ਮਾਪ",
    "discount": "ਛੂਟ",
    "discountLabel": "ਛੂਟ ਲੇਬਲ",
    "dispatchMonthDay": "ਡਿਸਪੈਚ ਮਹੀਨੇ ਦਾ ਦਿਨ *",
    "dispatcher": "ਡਿਸਪੈਚਰ",
    "dispatcherNotesLabel": "ਡਿਸਪੈਚਰ ਨੋਟਸ",
    "display": "ਡਿਸਪਲੇ",
    "displayMode": "ਡਿਸਪਲੇ ਮੋਡ",
    "displayNameLabel": "ਡਿਸਪਲੇ ਨਾਮ",
    "displayNameRequired": "ਡਿਸਪਲੇ ਨਾਮ ਦੀ ਲੋੜ ਹੈ",
    "displaySection": "ਡਿਸਪਲੇ ਸੈਕਸ਼ਨ",
    "do": "DO",
    "doModifier": "DO ਮੋਡੀਫਾਇਰ",
    "doModifierIsRequired": "DO ਮੋਡੀਫਾਇਰ ਦੀ ਲੋੜ ਹੈ",
    "doa": "DOA",
    "dobLabel": "ਜਨਮ ਮਿਤੀ",
    "dobRequired": "ਜਨਮ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "done": "ਹੋ ਗਿਆ",
    "dos": "DOS:",
    "dot": "ਡੀ.ਓ.ਟੀ",
    "dotPhysicalExamAnnual": "DOT ਸਰੀਰਕ ਪ੍ਰੀਖਿਆ (ਸਾਲਾਨਾ ਜਾਂ ਬੇਨਤੀ 'ਤੇ)",
    "downBaseAddress": "ਡਾਊਨ ਬੇਸ ਐਡਰੈੱਸ",
    "download": "ਡਾਊਨਲੋਡ ਕਰੋ",
    "downloadCsv": "CSV ਡਾਊਨਲੋਡ ਕਰੋ",
    "downloadPdf": "PDF ਡਾਊਨਲੋਡ ਕਰੋ",
    "downloadPdfReport": "PDF ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "downloadReport": "ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "drawRoute": "ਰੂਟ ਬਣਾਓ",
    "driveDistance": "ਡਰਾਈਵ ਦੂਰੀ",
    "driver": "ਡਰਾਈਵਰ",
    "driver-score-chartsWorks": "ਡਰਾਈਵਰ-ਸਕੋਰ-ਚਾਰਟ ਕੰਮ ਕਰਦਾ ਹੈ!",
    "driver2": "(ਡਰਾਈਵਰ)",
    "driverAddress": "ਡਰਾਈਵਰ ਦਾ ਪਤਾ",
    "driverAddressIsRequired": "ਡਰਾਈਵਰ ਦਾ ਪਤਾ ਲੋੜੀਂਦਾ ਹੈ",
    "driverAlerts": "ਡਰਾਈਵਰ ਚੇਤਾਵਨੀਆਂ",
    "driverBreak": "ਡਰਾਈਵਰ ਬਰੇਕ",
    "driverBreakdown": "ਡਰਾਈਵਰ ਦੀ ਖਰਾਬੀ",
    "driverImage": "ਡਰਾਈਵਰ ਚਿੱਤਰ",
    "driverInTake": "ਡਰਾਈਵਰ (%)",
    "driverInTakeIs": "ਡਰਾਈਵਰ ਇਨ ਟੇਕ ਦੀ ਲੋੜ ਹੈ",
    "driverInformation": "ਡਰਾਈਵਰ ਜਾਣਕਾਰੀ",
    "driverIsGettingLate": "ਡਰਾਈਵਰ ਲੇਟ ਹੋ ਰਿਹਾ ਹੈ",
    "driverIsIdle": "ਡਰਾਈਵਰ ਵਿਹਲਾ ਹੈ (ਕੋਈ ਯਾਤਰਾ ਨਹੀਂ)",
    "driverIsLate": "ਡਰਾਈਵਰ ਲੇਟ ਹੈ",
    "driverIsOverloaded": "ਡ੍ਰਾਈਵਰ ਓਵਰਲੋਡ ਹੈ (>12 ਯਾਤਰਾਵਾਂ)",
    "driverLoad": "ਡਰਾਈਵਰ ਲੋਡ",
    "driverName": "ਡਰਾਈਵਰ ਦਾ ਨਾਮ",
    "driverNotesLabel": "ਡਰਾਈਵਰ ਨੋਟਸ",
    "driverOdometer": "ਡਰਾਈਵਰ ਓਡੋਮੀਟਰ",
    "driverProfile": "ਡਰਾਈਵਰ ਪ੍ਰੋਫਾਈਲ",
    "driverRequired": "ਡਰਾਈਵਰ ਦੀ ਲੋੜ ਹੈ",
    "driverRoadTrainingEvidence": "ਡਰਾਈਵਰ ਰੋਡ ਟਰੇਨਿੰਗ (ਸਬੂਤ)",
    "driverSched": "ਡਰਾਈਵਰ ਅਨੁਸੂਚੀ",
    "driverShift": "ਡਰਾਈਵਰ ਸ਼ਿਫਟ",
    "driverShiftDayWise": "ਡਰਾਈਵਰ ਸ਼ਿਫਟ (ਦਿਨ ਅਨੁਸਾਰ)",
    "driverVerificationAlcohol": "ਡਰਾਈਵਰ ਵੈਰੀਫਿਕੇਸ਼ਨ (ਸ਼ਰਾਬ)",
    "driverVerificationDrug": "ਡਰਾਈਵਰ ਵੈਰੀਫਿਕੇਸ਼ਨ (ਡਰੱਗ)",
    "driverdisplayname": "driver.displayName",
    "driversDrugTest": "ਡਰਾਈਵਰ ਦਾ ਡਰੱਗ ਟੈਸਟ",
    "drivingRecordMeetsRequiremen": "ਡਰਾਈਵਿੰਗ ਰਿਕਾਰਡ (ਲੋੜ ਨੂੰ ਪੂਰਾ ਕਰਦਾ ਹੈ)",
    "drop": "ਸੁੱਟੋ",
    "dropoffAddress": "ਡਰਾਪਆਫ ਪਤਾ",
    "dropoffAddressIsRequired": "ਡ੍ਰੌਪਆਫ ਪਤਾ ਲੋੜੀਂਦਾ ਹੈ",
    "dropoffEarly": "ਜਲਦੀ ਛੱਡਣਾ:",
    "dropoffHeader": "ਡਰਾਪਆਫ",
    "dropoffLate": "ਡ੍ਰੌਪਆਫ ਦੇਰ:",
    "dropoffLateReason": "ਡ੍ਰੌਪਆਫ ਦੇਰੀ ਕਾਰਨ:",
    "dropoffLateReason2": "ਡ੍ਰੌਪਆਫ ਦੇਰ ਦਾ ਕਾਰਨ",
    "dropoffWise": "ਡਰਾਪਆਫ ਵਾਈਜ਼",
    "dryRun": "ਡਰਾਈ ਰਨ",
    "dryRunCode": "ਡਰਾਈ ਰਨ ਕੋਡ",
    "dryRunCodeIs": "ਡਰਾਈ ਰਨ ਕੋਡ ਦੀ ਲੋੜ ਹੈ",
    "dsr": "DSR:",
    "dt": "DT",
    "dt2": "DT:",
    "dueDay": "ਨਿਯਤ ਦਿਨ *",
    "duplicate": "ਡੁਪਲੀਕੇਟ",
    "durationIsRequired": "ਮਿਆਦ ਦੀ ਲੋੜ ਹੈ।",
    "dvCompetencyAssessmentIss": "DV ਯੋਗਤਾ ਮੁਲਾਂਕਣ (ISS)",
    "dvRequired": "DV ਦੀ ਲੋੜ ਹੈ",
    "earlyActionActualVsScheduled": "ਅਰਲੀ ਐਕਸ਼ਨ (ਅਸਲ ਸ਼ੁਰੂਆਤ ਬਨਾਮ ਅਨੁਸੂਚਿਤ)",
    "earlyEta": "ਛੇਤੀ ਈ.ਟੀ.ਏ",
    "editNotes": "ਨੋਟਸ ਦਾ ਸੰਪਾਦਨ ਕਰੋ",
    "editProfile": "ਪ੍ਰੋਫਾਈਲ ਦਾ ਸੰਪਾਦਨ ਕਰੋ",
    "editShift": "ਸ਼ਿਫਟ ਦਾ ਸੰਪਾਦਨ ਕਰੋ",
    "editTripHeader": "ਸੰਪਾਦਿਤ ਕਰੋ",
    "elderAbuseTraining": "ਬਜ਼ੁਰਗ ਦੁਰਵਿਵਹਾਰ ਦੀ ਸਿਖਲਾਈ",
    "eligibility": "ਯੋਗਤਾ",
    "eligibilityStatusIsRequired": "ਯੋਗਤਾ ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "eligible": "ਯੋਗ",
    "email": "ਈਮੇਲ:",
    "emailAddress": "ਈਮੇਲ ਪਤਾ",
    "emailAddressIsRequired": "ਈਮੇਲ ਪਤਾ ਲੋੜੀਂਦਾ ਹੈ",
    "emailConfiguration": "ਈਮੇਲ ਸੰਰਚਨਾ",
    "emailIsNotValid": "ਈਮੇਲ ਵੈਧ ਨਹੀਂ ਹੈ",
    "emailLabel": "ਈਮੇਲ",
    "emailRequired": "ਈਮੇਲ ਦੀ ਲੋੜ ਹੈ",
    "emergencyAndEvacuationTraini": "ਐਮਰਜੈਂਸੀ ਅਤੇ ਨਿਕਾਸੀ ਸਿਖਲਾਈ",
    "employeeId": "ਕਰਮਚਾਰੀ ਆਈ.ਡੀ",
    "employeeIdIsRequired": "ਕਰਮਚਾਰੀ ID ਦੀ ਲੋੜ ਹੈ",
    "employerNameIsRequired": "ਰੁਜ਼ਗਾਰਦਾਤਾ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "employmentType": "ਰੁਜ਼ਗਾਰ ਦੀ ਕਿਸਮ",
    "employmentTypeIsRequired": "ਰੁਜ਼ਗਾਰ ਦੀ ਕਿਸਮ ਲੋੜੀਂਦੀ ਹੈ",
    "emtDriver": "EMT ਡਰਾਈਵਰ",
    "emtLicense": "EMT ਲਾਇਸੰਸ",
    "emtLicenseImageIs": "EMT ਲਾਇਸੰਸ ਚਿੱਤਰ ਦੀ ਲੋੜ ਹੈ",
    "endDateLabel": "ਸਮਾਪਤੀ ਮਿਤੀ",
    "endDateRequired": "ਸਮਾਪਤੀ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "endOfShift": "ਸ਼ਿਫਟ ਦਾ ਅੰਤ",
    "endTime": "ਸਮਾਪਤੀ ਸਮਾਂ",
    "endTimeIsRequired": "ਸਮਾਪਤੀ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "ended": "(ਖਤਮ)",
    "endedAt": "ਇਸ ਸਮੇਂ ਸਮਾਪਤ ਹੋਇਆ:",
    "englishLanguageLabel": "ਅੰਗਰੇਜ਼ੀ",
    "ensureThereAreNo": "⚠️ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਕੋਲਨ ਦੇ ਆਲੇ-ਦੁਆਲੇ ਕੋਈ ਖਾਲੀ ਥਾਂ ਨਹੀਂ ਹੈ। ਖੋਜ ਨੂੰ ਟਰਿੱਗਰ ਕਰਨ ਲਈ ਘੱਟੋ-ਘੱਟ 3 ਅੱਖਰ ਲੋੜੀਂਦੇ ਹਨ।",
    "enterTitle": "ਸਿਰਲੇਖ ਦਰਜ ਕਰੋ",
    "enterYourEmail": "ਆਪਣੀ ਈਮੇਲ ਦਰਜ ਕਰੋ",
    "enterYourEmailAnd": "ਰੀਸੈਟ ਲਿੰਕ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਆਪਣੀ ਈਮੇਲ ਦਰਜ ਕਰੋ ਅਤੇ ਭੂਮਿਕਾ ਦੀ ਚੋਣ ਕਰੋ",
    "enterYourNewPassword": "ਹੇਠਾਂ ਆਪਣਾ ਨਵਾਂ ਪਾਸਵਰਡ ਦਾਖਲ ਕਰੋ",
    "equipmentsAreRequired": "ਉਪਕਰਨਾਂ ਦੀ ਲੋੜ ਹੈ",
    "esf": "ESF:",
    "estimatedFareLabel": "ਅਨੁਮਾਨਿਤ ਕਿਰਾਇਆ",
    "estimatedFares": "ਅਨੁਮਾਨਿਤ ਕਿਰਾਏ",
    "estimatedPickupTimeLabel": "ਅਨੁਮਾਨ PU:",
    "every": "ਹਰ",
    "exiting": "ਬਾਹਰ ਨਿਕਲ ਰਿਹਾ ਹੈ",
    "expandOnHover": "ਹੋਵਰ 'ਤੇ ਵਿਸਤਾਰ ਕਰੋ",
    "expectedAppointmentTimeLabel": "ਸੰਭਾਵਿਤ ਮੁਲਾਕਾਤ ਦਾ ਸਮਾਂ",
    "expectedAppointmentTimeMinError": "ਸੰਭਾਵਿਤ ਮੁਲਾਕਾਤ ਦਾ ਸਮਾਂ ਪਿਕਅੱਪ (ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ) ਤੋਂ ਪਹਿਲਾਂ ਨਹੀਂ ਹੋ ਸਕਦਾ।",
    "expectedAppointmentTimeRequired": "ਸੰਭਾਵਿਤ ਮੁਲਾਕਾਤ ਦਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "expenses": "ਖਰਚੇ",
    "expirationDate": "ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ",
    "expirationDateIsRequired": "ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "expired": "ਮਿਆਦ ਪੁੱਗ ਗਈ",
    "expiredTrips": "ਮਿਆਦ ਪੁੱਗ ਚੁੱਕੀਆਂ ਯਾਤਰਾਵਾਂ",
    "expiredTripsRoutes": "ਮਿਆਦ ਪੁੱਗ ਚੁੱਕੀਆਂ ਯਾਤਰਾਵਾਂ ਦੇ ਰਸਤੇ",
    "expiryDate": "ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ",
    "expiryDateIsRequired": "ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "exportCsv": "CSV ਨਿਰਯਾਤ ਕਰੋ",
    "extensiondispatcherNumber": "ਐਕਸਟੈਂਸ਼ਨ/ਡਿਸਪੈਚਰ ਨੰਬਰ",
    "extensiondispatcherNumberIsR": "ਐਕਸਟੈਂਸ਼ਨ/ਡਿਸਪੈਚਰ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "exteriorInformation": "ਬਾਹਰੀ ਜਾਣਕਾਰੀ",
    "fare": "ਕਿਰਾਇਆ",
    "fareInformation": "ਕਿਰਾਏ ਦੀ ਜਾਣਕਾਰੀ",
    "faxNumber": "ਫੈਕਸ ਨੰਬਰ",
    "feedback": "ਫੀਡਬੈਕ",
    "feet": "(ਪੈਰ)",
    "fetch": "ਪ੍ਰਾਪਤ ਕਰੋ",
    "fetchEta": "ETA ਪ੍ਰਾਪਤ ਕਰੋ",
    "fetchTime": "ਸਮਾਂ ਪ੍ਰਾਪਤ ਕਰੋ",
    "file": "(ਫਾਈਲ)",
    "fileIsRequired": "ਫਾਇਲ ਦੀ ਲੋੜ ਹੈ",
    "fileName": "ਫਾਈਲ ਦਾ ਨਾਮ",
    "filter": "ਫਿਲਟਰ",
    "fingerPrintLiveScan": "ਫਿੰਗਰ ਪ੍ਰਿੰਟ ਲਾਈਵ ਸਕੈਨ",
    "finished": "ਸਮਾਪਤ",
    "finishedAndCancelled": "ਮੁਕੰਮਲ ਅਤੇ ਰੱਦ",
    "finishedAt": "ਇਸ ਸਮੇਂ ਸਮਾਪਤ:",
    "finishedCompleted": "ਮੁਕੰਮਲ/ਮੁਕੰਮਲ",
    "finishedTimeIsRequired": "ਪੂਰਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "finishedTrips": "ਯਾਤਰਾਵਾਂ ਪੂਰੀਆਂ ਹੋਈਆਂ",
    "firstName": "ਪਹਿਲਾ ਨਾਮ",
    "firstNameIsRequired": "ਪਹਿਲਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "firstNameMustBe": "ਪਹਿਲਾ ਨਾਮ ਘੱਟੋ-ਘੱਟ 3 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "fleet": "ਫਲੀਟ",
    "fleetInformation": "ਫਲੀਟ ਜਾਣਕਾਰੀ",
    "fleetIsRequired": "ਫਲੀਟ ਦੀ ਲੋੜ ਹੈ",
    "floorLabel": "ਮੰਜ਼ਿਲ",
    "floorRequired": "ਮੰਜ਼ਿਲ ਦੀ ਲੋੜ ਹੈ",
    "florida": "ਫਲੋਰੀਡਾ",
    "flu": "ਫਲੂ",
    "fluVaccine": "ਫਲੂ ਵੈਕਸੀਨ",
    "fluVaccineDeclined": "ਫਲੂ ਵੈਕਸੀਨ ਅਸਵੀਕਾਰ ਕੀਤੀ ਗਈ",
    "focalPerson": "ਫੋਕਲ ਪਰਸਨ",
    "focalPersonInformation": "ਫੋਕਲ ਪਰਸਨ ਜਾਣਕਾਰੀ",
    "for": "ਲਈ",
    "force": "ਫੋਰਸ",
    "forcedAcceptTrips": "ਜ਼ਬਰਦਸਤੀ ਯਾਤਰਾਵਾਂ ਨੂੰ ਸਵੀਕਾਰ ਕਰੋ",
    "forgotPassword": "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ",
    "forgotPassword2": "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ ਹੋ?",
    "form837": "ਫਾਰਮ 837",
    "form837V2": "ਫਾਰਮ 837 v2",
    "freeQuota": "ਮੁਫਤ ਕੋਟਾ",
    "from": "ਤੋਂ",
    "fromIsRequired": "ਤੋਂ ਲੋੜੀਂਦਾ ਹੈ",
    "fsIsRequired": "FS ਦੀ ਲੋੜ ਹੈ",
    "fuelType": "ਬਾਲਣ ਦੀ ਕਿਸਮ",
    "fuelTypeIsRequired": "ਬਾਲਣ ਦੀ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "fullTime": "ਪੂਰਾ ਸਮਾਂ",
    "fundingSourceAndValidity": "ਫੰਡਿੰਗ ਸਰੋਤ ਅਤੇ ਵੈਧਤਾ ਸੀਮਾ ਦੀ ਲੋੜ ਹੈ",
    "fundingSourceLabel": "ਫੰਡਿੰਗ ਸਰੋਤ",
    "noViolation": "ਕੋਈ ਉਲੰਘਣਾ ਨਹੀਂ",
    "fundingSourceRequired": "ਫੰਡਿੰਗ ਸਰੋਤ ਦੀ ਲੋੜ ਹੈ",
    "fundingSources": "ਫੰਡਿੰਗ ਸਰੋਤ",
    "fundingSourcesAreRequired": "ਫੰਡਿੰਗ ਸਰੋਤਾਂ ਦੀ ਲੋੜ ਹੈ",
    "garage": "ਗੈਰੇਜ",
    "garageAddress": "ਗੈਰੇਜ ਦਾ ਪਤਾ",
    "garageAddressIsRequired": "ਗੈਰੇਜ ਦਾ ਪਤਾ ਲੋੜੀਂਦਾ ਹੈ",
    "gasCardNumber": "ਗੈਸ ਕਾਰਡ ਨੰਬਰ",
    "gasCardNumberIs": "ਗੈਸ ਕਾਰਡ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "genderFemale": "ਔਰਤ",
    "genderLabel": "ਲਿੰਗ",
    "genderMale": "ਨਰ",
    "genderOther": "ਹੋਰ",
    "genderRequired": "ਲਿੰਗ ਲੋੜੀਂਦਾ ਹੈ",
    "general": "ਜਨਰਲ",
    "georgia": "ਜਾਰਜੀਆ",
    "gisMiles": "GIS ਮੀਲਜ਼",
    "goBackHome": "ਘਰ ਵਾਪਸ ਜਾਓ",
    "googleMiles": "ਗੂਗਲ ਮੀਲਜ਼",
    "groundClearanceIsRequired": "ਗਰਾਊਂਡ ਕਲੀਅਰੈਂਸ ਦੀ ਲੋੜ ਹੈ",
    "groupByName": "ਨਾਮ ਦੁਆਰਾ ਸਮੂਹ",
    "groupImageIsRequired": "ਸਮੂਹ ਚਿੱਤਰ ਦੀ ਲੋੜ ਹੈ",
    "groupName": "ਗਰੁੱਪ ਦਾ ਨਾਮ",
    "groupNameIsRequired": "ਗਰੁੱਪ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "groups": "ਸਮੂਹ",
    "gurneyTraining": "ਗੁਰਨੀ ਸਿਖਲਾਈ",
    "handsFreeTraining": "ਹੱਥਾਂ ਦੀ ਮੁਫਤ ਸਿਖਲਾਈ",
    "haversineMiles": "ਹੈਵਰਸਾਈਨ ਮੀਲਜ਼",
    "height": "ਉਚਾਈ",
    "heightIsRequired": "ਉਚਾਈ ਦੀ ਲੋੜ ਹੈ",
    "hepatitis": "ਹੈਪੇਟਾਈਟਸ",
    "hhmm": "(HH:mm)",
    "hhmm2": "HHmm",
    "hhmm3": "HH:mm",
    "hideOneHourException": "ਇੱਕ ਘੰਟੇ ਦੇ ਅਪਵਾਦ ਨੂੰ ਲੁਕਾਓ",
    "hideThirdPartyDrivers": "ਥਰਡ ਪਾਰਟੀ ਡਰਾਈਵਰ ਲੁਕਾਓ",
    "hideUnassignedTrips": "ਗੈਰ-ਜ਼ਾਈਨ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ ਨੂੰ ਲੁਕਾਓ",
    "hipaaPhiTrainingValid": "HIPAA / PHI ਸਿਖਲਾਈ (ਹਮੇਸ਼ਾ ਲਈ ਵੈਧ)",
    "history": "ਇਤਿਹਾਸ",
    "holidayName": "ਛੁੱਟੀਆਂ ਦਾ ਨਾਮ",
    "holidayNameIsRequired": "ਛੁੱਟੀਆਂ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "hoodInformation": "ਹੁੱਡ ਜਾਣਕਾਰੀ",
    "hospitalized": "ਹਸਪਤਾਲ ਵਿੱਚ ਭਰਤੀ",
    "host": "ਮੇਜ਼ਬਾਨ",
    "howToUseThe": "🔍 ਖੋਜ ਦੀ ਵਰਤੋਂ ਕਿਵੇਂ ਕਰੀਏ",
    "iaal": "ਆਈਏਏਐਲ",
    "ifYouAlterThe": "ਜੇਕਰ ਤੁਸੀਂ ਕਿਸੇ ਯਾਤਰਾ ਦੀ ਜਾਣਕਾਰੀ ਨੂੰ ਇਸ ਤਰ੍ਹਾਂ ਬਦਲਦੇ ਹੋ ਕਿ ਇਹ ਅਸਲ ਯਾਤਰਾ ਦੇ ਵੇਰਵਿਆਂ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀ ਹੈ, ਤਾਂ ਤੁਸੀਂ ਇੱਕ ਗਲਤ ਬਿਆਨ ਦਰਜ ਕਰ ਰਹੇ ਹੋ ਅਤੇ ਅਪਰਾਧ ਕਰ ਰਹੇ ਹੋ। ਕੋਈ ਵੀ ਵਿਅਕਤੀ ਝੂਠਾ ਬਿਆਨ ਦਰਜ ਕਰਵਾਏਗਾ ਤਾਂ ਉਸ ਵਿਰੁੱਧ ਕਾਨੂੰਨ ਦੀ ਪੂਰੀ ਹੱਦ ਤੱਕ ਮੁਕੱਦਮਾ ਚਲਾਇਆ ਜਾਵੇਗਾ।",
    "image": "ਚਿੱਤਰ",
    "imageIsRequired": "ਚਿੱਤਰ ਲੋੜੀਂਦਾ ਹੈ",
    "img-corporate": "img-ਕਾਰਪੋਰੇਟ",
    "importFile": "ਫਾਈਲ ਆਯਾਤ ਕਰੋ",
    "importingTripsFromBrokers": "ਦਲਾਲਾਂ ਤੋਂ ਯਾਤਰਾਵਾਂ ਆਯਾਤ ਕਰਨਾ",
    "inActiveReason": "ਸਰਗਰਮ ਕਾਰਨ ਵਿੱਚ",
    "inActiveReasonIs": "ਸਰਗਰਮ ਕਾਰਨ ਦੀ ਲੋੜ ਹੈ",
    "inMinutes": "(ਮਿੰਟਾਂ ਵਿੱਚ)",
    "inProgress": "ਪ੍ਰਗਤੀ ਵਿੱਚ ਹੈ",
    "inProgressTrips": "ਪ੍ਰਗਤੀ ਯਾਤਰਾਵਾਂ ਵਿੱਚ",
    "inProgressRoutes": "ਜਾਰੀ ਰੂਟ",
    "inReview": "ਸਮੀਖਿਆ ਵਿੱਚ",
    "inVehicle": "ਵਾਹਨ ਵਿਚ",
    "inactive": "ਅਕਿਰਿਆਸ਼ੀਲ",
    "incentive": "ਪ੍ਰੋਤਸਾਹਨ",
    "incentiveIsRequired": "ਪ੍ਰੋਤਸਾਹਨ ਦੀ ਲੋੜ ਹੈ",
    "indiana": "ਇੰਡੀਆਨਾ",
    "ineligible": "ਅਯੋਗ",
    "info": "ਜਾਣਕਾਰੀ",
    "informDriver": "ਡਰਾਈਵਰ ਨੂੰ ਸੂਚਿਤ ਕਰੋ",
    "information": "ਜਾਣਕਾਰੀ",
    "inspectionPassOrFail": "ਨਿਰੀਖਣ ਪਾਸ ਜਾਂ ਫੇਲ ਦੀ ਲੋੜ ਹੈ",
    "interiorInformation": "ਅੰਦਰੂਨੀ ਜਾਣਕਾਰੀ",
    "invalidEmailFormat": "ਅਵੈਧ ਈਮੇਲ ਫਾਰਮੈਟ",
    "invalidTrip": "ਅਵੈਧ ਯਾਤਰਾ",
    "invoice": "ਚਲਾਨ",
    "invoices": "ਚਲਾਨ",
    "ipaLabel": "IPA / FECA ਨੰਬਰ",
    "ipaRequired": "IPA/FECA ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "ipcr": "ਆਈ.ਪੀ.ਸੀ.ਆਰ",
    "isAcknowledgementOnFile": "ਕੀ ਰਸੀਦ ਫਾਈਲ 'ਤੇ ਹੈ?",
    "isCertificateOnFile": "ਕੀ ਸਰਟੀਫਿਕੇਟ ਫਾਈਲ 'ਤੇ ਹੈ?",
    "isWave": "ਲਹਿਰ ਹੈ",
    "issueDate": "ਜਾਰੀ ਕਰਨ ਦੀ ਮਿਤੀ",
    "issueDateIsRequired": "ਜਾਰੀ ਕਰਨ ਦੀ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "itineries": "ਯਾਤਰਾਵਾਂ",
    "kpisdriverdisplayname": "kpis.driver.displayName",
    "language": "ਭਾਸ਼ਾ",
    "lastInspectionDateIs": "ਆਖਰੀ ਨਿਰੀਖਣ ਮਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "lastName": "ਆਖਰੀ ਨਾਮ",
    "lastNameIsRequired": "ਆਖਰੀ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "lastNameMustBe": "ਆਖਰੀ ਨਾਮ ਘੱਟੋ-ਘੱਟ 3 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "lateCushion": "ਲੇਟ ਕੁਸ਼ਨ",
    "lateCushionIsRequired": "ਲੇਟ ਕੁਸ਼ਨ ਦੀ ਲੋੜ ਹੈ",
    "lateEta": "ਦੇਰ ਨਾਲ ਈ.ਟੀ.ਏ",
    "lbs": "(lbs)",
    "legCancellationAlert": "ਲੱਤ ਰੱਦ ਕਰਨ ਦੀ ਚਿਤਾਵਨੀ",
    "legLabel": "ਲੱਤ-",
    "legalInformation": "ਕਾਨੂੰਨੀ ਜਾਣਕਾਰੀ",
    "legalName": "ਕਨੂੰਨੀ ਨਾਮ",
    "legalNameIsRequired": "ਕਨੂੰਨੀ ਨਾਮ ਦੀ ਲੋੜ ਹੈ",
    "legalNameMustBe": "ਕਨੂੰਨੀ ਨਾਮ ਘੱਟੋ-ਘੱਟ 3 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "lengthIsRequired": "ਲੰਬਾਈ ਦੀ ਲੋੜ ਹੈ",
    "lengthMustBe3": "ਲੰਬਾਈ 3 ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ",
    "levelOfServiceImage": "ਸੇਵਾ ਚਿੱਤਰ ਦਾ ਪੱਧਰ",
    "levelOfServiceLabel": "ਸੇਵਾ ਦਾ ਪੱਧਰ",
    "levelOfServiceRequired": "ਸੇਵਾ ਦਾ ਪੱਧਰ ਲੋੜੀਂਦਾ ਹੈ",
    "levelofservice-image": "levelOfService-ਚਿੱਤਰ",
    "licenseInformation": "ਲਾਇਸੰਸ ਜਾਣਕਾਰੀ",
    "licenseNumber": "ਲਾਇਸੰਸ ਨੰਬਰ",
    "licenseNumberIsRequired": "ਲਾਇਸੰਸ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "licensePlate": "ਲਾਇਸੰਸ ਪਲੇਟ",
    "licensePlateInformation": "ਲਾਇਸੰਸ ਪਲੇਟ ਜਾਣਕਾਰੀ",
    "licensePlateIsRequired": "ਲਾਇਸੰਸ ਪਲੇਟ ਦੀ ਲੋੜ ਹੈ",
    "lightsInformation": "ਲਾਈਟਾਂ ਦੀ ਜਾਣਕਾਰੀ",
    "limitation": "ਸੀਮਾ",
    "limitations": "ਸੀਮਾਵਾਂ",
    "line": "ਲਾਈਨ",
    "list": "ਸੂਚੀ",
    "listView": "ਸੂਚੀ ਦ੍ਰਿਸ਼",
    "livescanDojFbi": "ਲਾਈਵਸਕੈਨ (DOJ + FBI)",
    "livescanDojOnly": "ਲਾਈਵਸਕੈਨ (ਸਿਰਫ਼ DOJ)",
    "load": "ਲੋਡ ਕਰੋ",
    "loadTimeIsRequired": "ਲੋਡ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "loadedMilesRateIs": "ਲੋਡ ਕੀਤੇ ਮੀਲ ਦੀ ਦਰ ਦੀ ਲੋੜ ਹੈ",
    "loadedTime": "ਲੋਡ ਕੀਤਾ ਸਮਾਂ",
    "loadedTimeToDropoff": "ਲੋਡ ਹੋਣ ਦਾ ਸਮਾਂ (ਡ੍ਰੌਪਆਫ ਲਈ)",
    "loginInformation": "ਲੌਗਇਨ ਜਾਣਕਾਰੀ",
    "logisticareTemplate": "LogistiCare ਟੈਂਪਲੇਟ",
    "logo": "ਲੋਗੋ",
    "logout": "ਲਾਗਆਉਟ",
    "logs": "ਲਾਗ",
    "los": "LOS:",
    "losAndSpaceType": "Los ਅਤੇ ਸਪੇਸ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "lt": "LT",
    "lt2": "LT:",
    "lunch": "ਦੁਪਹਿਰ ਦਾ ਖਾਣਾ",
    "maintenanceInformation": "ਰੱਖ-ਰਖਾਅ ਦੀ ਜਾਣਕਾਰੀ",
    "maintenances": "ਰੱਖ-ਰਖਾਅ",
    "makeItLive": "ਇਸਨੂੰ ਲਾਈਵ ਬਣਾਓ",
    "makeModel": "ਬਣਾਓ ਅਤੇ ਮਾਡਲ",
    "makeModelIsRequired": "ਮੇਕ ਅਤੇ ਮਾਡਲ ਦੀ ਲੋੜ ਹੈ",
    "mandatoryForCms1500": "(CMS 1500 ਫਾਰਮ ਲਈ ਲਾਜ਼ਮੀ)",
    "mandatoryForMedicaidAnd": "(ਮੈਡੀਕੇਡ ਅਤੇ CMS 1500 ਫਾਰਮਾਂ ਲਈ ਲਾਜ਼ਮੀ)",
    "mandatoryForMedicaidAuth": "(ਮੈਡੀਕੇਡ ਪ੍ਰਮਾਣੀਕਰਣ ਫਾਰਮ ਲਈ ਲਾਜ਼ਮੀ)",
    "manifest": "ਪ੍ਰਗਟ",
    "manifestLegend": "ਪ੍ਰਗਟ ਦੰਤਕਥਾ",
    "manual": "ਮੈਨੁਅਲ",
    "manualGenerate": "ਮੈਨੁਅਲ ਜਨਰੇਟ",
    "manualTrip": "ਦਸਤੀ ਯਾਤਰਾ",
    "mapperIsRequired": "ਮੈਪਰ ਦੀ ਲੋੜ ਹੈ",
    "markComplete": "ਮੁਕੰਮਲ ਦੀ ਨਿਸ਼ਾਨਦੇਹੀ ਕਰੋ",
    "markMemberReady": "ਮੈਂਬਰ ਨੂੰ ਤਿਆਰ ਵਜੋਂ ਚਿੰਨ੍ਹਿਤ ਕਰੋ",
    "markedReady": "ਤਿਆਰ ਵਜੋਂ ਚਿੰਨ੍ਹਿਤ ਕੀਤਾ ਗਿਆ",
    "markedReadyRoutes": "ਮਾਰਕ ਕੀਤੇ ਤਿਆਰ ਰਸਤੇ",
    "markedReadyTrips": "ਨਿਸ਼ਾਨਬੱਧ ਤਿਆਰ ਯਾਤਰਾਵਾਂ",
    "marketplace": "ਬਾਜ਼ਾਰ",
    "maxDistance": "ਅਧਿਕਤਮ ਦੂਰੀ:",
    "maxOnboardTime": "ਅਧਿਕਤਮ ਔਨਬੋਰਡ ਸਮਾਂ:",
    "maxTrips": "ਅਧਿਕਤਮ ਯਾਤਰਾਵਾਂ:",
    "meal": "ਭੋਜਨ",
    "mealBreak": "ਭੋਜਨ ਬਰੇਕ",
    "mechanicverificationsignatur": "mechanicVerification.signature",
    "medex": "MEDEX",
    "medical": "ਮੈਡੀਕਲ",
    "medicalIdIsRequired": "ਮੈਡੀਕਲ ਆਈਡੀ ਦੀ ਲੋੜ ਹੈ",
    "medicalLogo": "ਮੈਡੀਕਲ ਲੋਗੋ",
    "medicalTrip": "ਮੈਡੀਕਲ ਯਾਤਰਾ",
    "member-image": "ਮੈਂਬਰ-ਚਿੱਤਰ",
    "memberLabel": "ਮੈਂਬਰ",
    "memberLoading": "ਮੈਂਬਰ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ",
    "memberName": "ਮੈਂਬਰ ਦਾ ਨਾਮ",
    "memberNotVisible": "ਮੈਂਬਰ ਦਿਖਾਈ ਨਹੀਂ ਦੇ ਰਿਹਾ",
    "memberOnboard": "ਮੈਂਬਰ ਔਨਬੋਰਡ",
    "memberOnboardAt": "ਮੈਂਬਰ ਔਨਬੋਰਡ 'ਤੇ:",
    "memberRequired": "ਮੈਂਬਰ ਦੀ ਲੋੜ ਹੈ",
    "memberRoleIsRequired": "ਮੈਂਬਰ ਰੋਲ ਦੀ ਲੋੜ ਹੈ",
    "memberStatus": "ਮੈਂਬਰ ਸਥਿਤੀ",
    "memberType": "ਮੈਂਬਰ ਦੀ ਕਿਸਮ",
    "memberTypeIsRequired": "ਮੈਂਬਰ ਦੀ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "memberdisplayname": "member.displayName",
    "membersPhoneNumber": "ਮੈਂਬਰ ਦਾ ਫ਼ੋਨ ਨੰਬਰ",
    "merge": "ਮਿਲਾਓ",
    "messageAlerts": "ਸੁਨੇਹਾ ਚੇਤਾਵਨੀਆਂ",
    "messages": "ਸੁਨੇਹੇ",
    "methadone": "ਮੈਥਾਡੋਨ",
    "method": "ਵਿਧੀ",
    "methodIsRequired": "ਵਿਧੀ ਦੀ ਲੋੜ ਹੈ",
    "mfa": "(MFA)",
    "mfb": "Mfb",
    "mi": "mi",
    "mid": "ਮੱਧ",
    "middleName": "ਮੱਧ ਨਾਮ",
    "middleNameIsRequired": "ਵਿਚਕਾਰਲਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "mile": "ਮੀਲ",
    "miles": "ਮੀਲ",
    "milesForBucksDriver": "ਬਕਸ ਡਰਾਈਵਰ ਲਈ ਮੀਲ",
    "milesForBucksPanel": "ਬਕਸ ਪੈਨਲ ਲਈ ਮੀਲ",
    "milesLabel": "ਮੀਲ",
    "milesRequired": "ਮੀਲ ਦੀ ਲੋੜ ਹੈ",
    "minimum3CharactersRequired": "ਘੱਟੋ-ਘੱਟ 3 ਅੱਖਰ ਲੋੜੀਂਦੇ ਹਨ",
    "minimum5CharactersRequired": "ਘੱਟੋ-ਘੱਟ 5 ਅੱਖਰ ਲੋੜੀਂਦੇ ਹਨ",
    "mins": "ਮਿੰਟ",
    "minutes": "ਮਿੰਟ",
    "minutesIsRequired": "ਮਿੰਟਾਂ ਦੀ ਲੋੜ ਹੈ",
    "mm": "(mm)",
    "mmddyyyy": "MM/DD/YYYY",
    "mobileNumberLabel": "ਮੋਬਾਈਲ ਨੰਬਰ",
    "mobileNumberRequired": "ਮੋਬਾਈਲ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "model": "ਮਾਡਲ",
    "modelIsRequired": "ਮਾਡਲ ਦੀ ਲੋੜ ਹੈ",
    "modifierLabel": "ਸੋਧਕ",
    "modifierRequired": "ਸੋਧਕ ਦੀ ਲੋੜ ਹੈ",
    "moicu": "ਐਮ.ਓ.ਆਈ.ਸੀ.ਯੂ",
    "moreFeaturesComingSoon": "📝 ਹੋਰ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਜਲਦੀ ਆ ਰਹੀਆਂ ਹਨ",
    "moreLabel": "ਹੋਰ...",
    "na": "N/A",
    "name": "ਨਾਮ",
    "nameIsRequired": "ਨਾਮ ਦੀ ਲੋੜ ਹੈ",
    "nemt": "NEMT",
    "nemtStatistics": "NEMT ਅੰਕੜੇ",
    "newExpense": "ਨਵਾਂ ਖਰਚਾ",
    "newInspection": "ਨਵਾਂ ਨਿਰੀਖਣ",
    "newPassword": "ਨਵਾਂ ਪਾਸਵਰਡ",
    "newPasswordIsRequired": "ਨਵਾਂ ਪਾਸਵਰਡ ਲੋੜੀਂਦਾ ਹੈ",
    "no": "ਨੰ",
    "noAgentTripsTo": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਏਜੰਟ ਯਾਤਰਾਵਾਂ ਨਹੀਂ ਹਨ",
    "noAnswer": "ਕੋਈ ਜਵਾਬ ਨਹੀਂ",
    "noCompanyDetailsTo": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਕੰਪਨੀ ਵੇਰਵੇ ਨਹੀਂ ਹਨ",
    "noCtcTripTo": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ CTC ਯਾਤਰਾ ਨਹੀਂ ਹੈ",
    "noDataToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਹੈ",
    "noDetailsToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਵੇਰਵੇ ਨਹੀਂ ਹਨ",
    "noDirtRoadTrips": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਗੰਦਗੀ ਵਾਲੀਆਂ ਸੜਕਾਂ ਨਹੀਂ ਹਨ",
    "noDriverDetailsTo": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਡਰਾਈਵਰ ਵੇਰਵੇ ਨਹੀਂ ਹਨ",
    "noEarning": "ਕੋਈ ਕਮਾਈ ਨਹੀਂ",
    "noEarningsToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਕਮਾਈ ਨਹੀਂ",
    "noMessageToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਸੁਨੇਹਾ ਨਹੀਂ",
    "noNotificationsToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਸੂਚਨਾਵਾਂ ਨਹੀਂ ਹਨ",
    "noOfEscortsLabel": "ਐਸਕਾਰਟਸ ਦੀ ਸੰਖਿਆ",
    "noOfEscortsRequired": "ਏਸਕੌਰਟਸ ਦੀ ਗਿਣਤੀ ਦੀ ਲੋੜ ਹੈ",
    "noOfRoutes": "ਰੂਟਾਂ ਦੀ ਸੰਖਿਆ",
    "noOfRoutesAre": "ਰੂਟਾਂ ਦੀ ਗਿਣਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "noOfSeats": "ਸੀਟਾਂ ਦੀ ਸੰਖਿਆ",
    "noOfSeatsAre": "ਸੀਟਾਂ ਦੀ ਗਿਣਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "noParsedFileFound": "ਕੋਈ ਪਾਰਸ ਫਾਈਲ ਨਹੀਂ ਮਿਲੀ",
    "noRecords": "ਕੋਈ ਰਿਕਾਰਡ ਨਹੀਂ",
    "noShowCharges": "ਕੋਈ ਸ਼ੋਅ ਚਾਰਜ ਨਹੀਂ",
    "noShowChargesIs": "ਕੋਈ ਸ਼ੋਅ ਚਾਰਜ ਦੀ ਲੋੜ ਨਹੀਂ ਹੈ",
    "noStatisticsToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਅੰਕੜੇ ਨਹੀਂ",
    "noTripLogsTo": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਟ੍ਰਿਪ ਲੌਗ ਨਹੀਂ",
    "noTripsAssign": "ਕੋਈ ਯਾਤਰਾਵਾਂ ਅਸਾਈਨ ਨਹੀਂ",
    "noTripsToShow": "ਦਿਖਾਉਣ ਲਈ ਕੋਈ ਯਾਤਰਾਵਾਂ ਨਹੀਂ ਹਨ",
    "noUnassignedTrips": "ਕੋਈ ਅਸਾਈਨ ਨਹੀਂ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "non-transportVehicle": "ਗੈਰ-ਆਵਾਜਾਈ ਵਾਹਨ",
    "none": "ਕੋਈ ਨਹੀਂ",
    "notAvailable": "ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    "notEligible": "ਯੋਗ ਨਹੀਂ",
    "note": "ਨੋਟ ਕਰੋ",
    "notes": "ਨੋਟਸ",
    "notesAreRequired": "ਨੋਟਸ ਦੀ ਲੋੜ ਹੈ",
    "notificationMethod": "ਸੂਚਨਾ ਵਿਧੀ",
    "notifications": "ਸੂਚਨਾਵਾਂ",
    "odometer": "ਓਡੋਮੀਟਰ",
    "odometerBegin": "ਓਡੋਮੀਟਰ ਸ਼ੁਰੂ",
    "odometerBeginIsRequired": "ਓਡੋਮੀਟਰ ਸ਼ੁਰੂ ਕਰਨ ਦੀ ਲੋੜ ਹੈ",
    "odometerBeginReadingIs": "ਓਡੋਮੀਟਰ ਬਿਗਨ ਰੀਡਿੰਗ ਦੀ ਲੋੜ ਹੈ",
    "odometerEndIsRequired": "ਓਡੋਮੀਟਰ ਐਂਡ ਦੀ ਲੋੜ ਹੈ",
    "odometerRequired": "ਓਡੋਮੀਟਰ ਦੀ ਲੋੜ ਹੈ",
    "odometerStart": "ਓਡੋਮੀਟਰ ਸ਼ੁਰੂ",
    "odometerStartIsRequired": "ਓਡੋਮੀਟਰ ਸ਼ੁਰੂ ਕਰਨ ਦੀ ਲੋੜ ਹੈ",
    "odometerStop": "ਓਡੋਮੀਟਰ ਸਟਾਪ",
    "odometerStopIsRequired": "ਓਡੋਮੀਟਰ ਸਟਾਪ ਦੀ ਲੋੜ ਹੈ",
    "of": "ਦੇ",
    "offeredAccepted": "ਦੀ ਪੇਸ਼ਕਸ਼ ਕੀਤੀ / ਸਵੀਕਾਰ ਕੀਤੀ",
    "offeredTrips": "ਯਾਤਰਾਵਾਂ ਦੀ ਪੇਸ਼ਕਸ਼ ਕੀਤੀ",
    "offline": "ਔਫਲਾਈਨ",
    "oigScreening": "OIG ਸਕ੍ਰੀਨਿੰਗ",
    "onScene": "ਮੌਕੇ 'ਤੇ:",
    "onScene2": "ਸੀਨ 'ਤੇ",
    "onSceneReport": "ਸੀਨ ਰਿਪੋਰਟ 'ਤੇ",
    "onWay": "ਰਾਹ 'ਤੇ",
    "onWayAt": "ਰਸਤੇ ਵਿੱਚ:",
    "onboard": "ਜਹਾਜ਼ 'ਤੇ",
    "oneHourException": "1 ਘੰਟੇ ਦਾ ਅਪਵਾਦ",
    "onq": "ONQ",
    "onscene": "ਆਨਸੀਨ",
    "onsceneTimeIsRequired": "ਮੌਕੇ ਦਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "onway": "ਚੱਲ ਰਿਹਾ ਹੈ",
    "open": "ਖੋਲ੍ਹੋ",
    "openMainMenu": "ਮੁੱਖ ਮੀਨੂ ਖੋਲ੍ਹੋ",
    "openUserMenu": "ਉਪਭੋਗਤਾ ਮੀਨੂ ਖੋਲ੍ਹੋ",
    "opener": "ਓਪਨਰ",
    "operations": "ਸੰਚਾਲਨ",
    "operationsManager": "ਓਪਰੇਸ਼ਨ ਮੈਨੇਜਰ",
    "operationsManagerIsRequired": "ਓਪਰੇਸ਼ਨ ਮੈਨੇਜਰ ਦੀ ਲੋੜ ਹੈ",
    "optIn": "ਓਪੀਟੀ ਇਨ",
    "orDragAndDrop": "ਜਾਂ ਖਿੱਚੋ ਅਤੇ ਸੁੱਟੋ",
    "ordAct": "ਆਦੇਸ਼/ਐਕਟ",
    "order": "ਆਰਡਰ",
    "orderIsRequired": "ਆਰਡਰ ਦੀ ਲੋੜ ਹੈ",
    "organizationId": "ਸੰਸਥਾ ਆਈ.ਡੀ",
    "organizationIdIsRequired": "ਸੰਗਠਨ ਆਈ.ਡੀ. ਦੀ ਲੋੜ ਹੈ",
    "otherInformation": "ਹੋਰ ਜਾਣਕਾਰੀ",
    "otherLegsHeader": "ਹੋਰ ਲੱਤਾਂ",
    "others": "ਹੋਰ",
    "otp": "OTP",
    "outsideShift": "ਸ਼ਿਫਟ ਤੋਂ ਬਾਹਰ",
    "outstandingTrips": "ਸ਼ਾਨਦਾਰ ਯਾਤਰਾਵਾਂ",
    "ownerDetails": "ਮਾਲਕ ਦੇ ਵੇਰਵੇ",
    "pageNotFound": "ਪੰਨਾ ਨਹੀਂ ਮਿਲਿਆ",
    "paid": "ਭੁਗਤਾਨ ਕੀਤਾ",
    "panel": "ਪੈਨਲ",
    "parseTrips": "ਪਾਰਸ ਯਾਤਰਾਵਾਂ",
    "partTime": "ਪਾਰਟ ਟਾਈਮ",
    "partner": "ਸਾਥੀ",
    "passenger": "ਯਾਤਰੀ",
    "passengerAssistanceAndCultur": "ਯਾਤਰੀ ਸਹਾਇਤਾ ਅਤੇ ਸੱਭਿਆਚਾਰਕ ਸਿਖਲਾਈ (EXP)",
    "passengerInformation": "ਯਾਤਰੀ ਜਾਣਕਾਰੀ",
    "password": "ਪਾਸਵਰਡ",
    "passwordInformation": "ਪਾਸਵਰਡ ਜਾਣਕਾਰੀ",
    "passwordIsRequired": "ਪਾਸਵਰਡ ਦੀ ਲੋੜ ਹੈ",
    "passwordMustBeAtleast": "ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
    "passwordMustBeAtleast2": "ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
    "passwordMustBeMaximum": "ਪਾਸਵਰਡ ਵੱਧ ਤੋਂ ਵੱਧ 16 ਅੱਖਰ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
    "passwordMustBeMaximum2": "ਪਾਸਵਰਡ ਵੱਧ ਤੋਂ ਵੱਧ 16 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
    "patient": "ਮਰੀਜ਼",
    "paymentConfirmed": "ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਗਈ",
    "paymentUnconfirmed": "ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਹੋਈ",
    "payorLabel": "ਪੇਅਰ",
    "pending": "ਬਕਾਇਆ",
    "pendingFee": "ਬਕਾਇਆ ਫੀਸ *",
    "perMile": "ਪ੍ਰਤੀ ਮੀਲ",
    "perMileCode": "ਪ੍ਰਤੀ ਮੀਲ ਕੋਡ",
    "perMileCodeIs": "ਪ੍ਰਤੀ ਮੀਲ ਕੋਡ ਦੀ ਲੋੜ ਹੈ",
    "perMileIsRequired": "ਪ੍ਰਤੀ ਮੀਲ ਦੀ ਲੋੜ ਹੈ",
    "perMinIsRequired": "ਪ੍ਰਤੀ ਮਿੰਟ ਦੀ ਲੋੜ ਹੈ",
    "perMinute": "ਪ੍ਰਤੀ ਮਿੰਟ",
    "period": "ਮਿਆਦ",
    "permissions": "ਇਜਾਜ਼ਤਾਂ",
    "person": "ਵਿਅਕਤੀ",
    "phoneNumberLabel": "ਫ਼ੋਨ ਨੰਬਰ",
    "phoneNumberRequired": "ਫ਼ੋਨ ਨੰਬਰ ਲੋੜੀਂਦਾ ਹੈ",
    "pickupAddress": "ਪਿਕਅੱਪ ਪਤਾ",
    "pickupAddressIsRequired": "ਪਿਕਅੱਪ ਪਤਾ ਲੋੜੀਂਦਾ ਹੈ",
    "pickupEarly": "ਜਲਦੀ ਪਿਕਅੱਪ:",
    "pickupHeader": "ਪਿਕਅੱਪ",
    "pickupLate": "ਪਿਕਅੱਪ ਲੇਟ:",
    "pickupLateReason": "ਪਿਕਅੱਪ ਦੇਰ ਕਾਰਨ",
    "pickupLateReasons": "ਪਿਕਅੱਪ ਦੇਰੀ ਕਾਰਨ:",
    "pickupTme": "ਪਿਕਅੱਪ Tme",
    "pickupWise": "ਪਿਕਅੱਪ ਵਾਈਜ਼",
    "placeNameLabel": "ਘਰ/ਸੁਵਿਧਾ ਦਾ ਨਾਮ",
    "placeNameRequired": "ਘਰ/ਸੁਵਿਧਾ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "planner": "ਯੋਜਨਾਕਾਰ",
    "platform": "ਪਲੇਟਫਾਰਮ",
    "platformIsRequired": "ਪਲੇਟਫਾਰਮ ਦੀ ਲੋੜ ਹੈ",
    "platformportal": "ਪਲੇਟਫਾਰਮ/ਪੋਰਟਲ",
    "platformportalIsRequired": "ਪਲੇਟਫਾਰਮ/ਪੋਰਟਲ ਦੀ ਲੋੜ ਹੈ",
    "pleaseChooseAnyAbove": "ਕਿਰਪਾ ਕਰਕੇ ਉਪਰੋਕਤ ਕੋਈ ਵੀ ਕਾਰਨ ਚੁਣੋ",
    "pleaseEnterDispatcherNotes": "ਕਿਰਪਾ ਕਰਕੇ ਡਿਸਪੈਚਰ ਨੋਟਸ ਦਾਖਲ ਕਰੋ",
    "pleaseEnterForDriver": "ਕਿਰਪਾ ਕਰਕੇ ਡਰਾਈਵਰ ਨੋਟਸ ਲਈ ਦਾਖਲ ਕਰੋ",
    "pleaseEnterTheClient": "ਕਿਰਪਾ ਕਰਕੇ ਗਾਹਕ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    "pleaseEnterTheDate": "ਕਿਰਪਾ ਕਰਕੇ ਡਰਾਈਵਰ ਦੇ ਮੋਟਰ ਵਾਹਨ ਰਿਕਾਰਡ ਦੀ ਜਾਂਚ ਦੀ ਮਿਤੀ ਦਰਜ ਕਰੋ",
    "pleaseEnterTheDescription": "ਕਿਰਪਾ ਕਰਕੇ ਵਰਣਨ ਦਾਖਲ ਕਰੋ",
    "pleaseEnterTheNote": "ਕਿਰਪਾ ਕਰਕੇ ਨੋਟ ਦਰਜ ਕਰੋ",
    "pleaseEnterTheNotes": "ਕਿਰਪਾ ਕਰਕੇ ਨੋਟਸ ਦਾਖਲ ਕਰੋ",
    "pleaseEnterThePrivate": "ਕਿਰਪਾ ਕਰਕੇ ਨਿੱਜੀ ਨੋਟ ਦਰਜ ਕਰੋ",
    "pleaseEnterTheTime": "ਕਿਰਪਾ ਕਰਕੇ ਸਮਾਂ ਖੇਤਰ ਦਾਖਲ ਕਰੋ",
    "pleaseNoteByUsing": "ਕਿਰਪਾ ਕਰਕੇ ਨੋਟ ਕਰੋ, ਇਸ ਵਿਸ਼ੇਸ਼ਤਾ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਤੁਹਾਨੂੰ ਕਿਸੇ ਵੀ ਯਾਤਰਾ ਨੂੰ ਛੱਡ ਦੇਣਾ ਚਾਹੀਦਾ ਹੈ ਜੋ ਜ਼ਮੀਨ 'ਤੇ ਨਹੀਂ ਕੀਤੀਆਂ ਗਈਆਂ ਹਨ ਤਾਂ ਜੋ ਸਿਸਟਮ 'ਤੇ ਕੋਈ ਵੀ ਜਾਣਕਾਰੀ ਨਾ ਘੜੀ ਗਈ ਹੋਵੇ।",
    "pleaseSelectAtLeast": "ਕਿਰਪਾ ਕਰਕੇ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਡਰਾਈਵਰ ਚੁਣੋ।",
    "pleaseSelectCompanyTo": "ਕਿਰਪਾ ਕਰਕੇ ਰਿਕਾਰਡ ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਨ ਲਈ ਕੰਪਨੀ ਦੀ ਚੋਣ ਕਰੋ",
    "pleaseSelectPrimaryMember": "ਕਿਰਪਾ ਕਰਕੇ ਪ੍ਰਾਇਮਰੀ ਮੈਂਬਰ ਚੁਣੋ",
    "pleaseSelectTimeIn": "ਕਿਰਪਾ ਕਰਕੇ ਵਿੱਚ ਸਮਾਂ ਚੁਣੋ",
    "pleaseTakeNoticeFiling": "ਕਿਰਪਾ ਕਰਕੇ ਧਿਆਨ ਦਿਓ: ਝੂਠੇ ਬਿਆਨ ਦਰਜ ਕਰਨਾ ਇੱਕ ਅਪਰਾਧ ਹੈ",
    "pngJpgGifUp": "PNG, JPG, GIF 10MB ਤੱਕ",
    "policeClearance": "ਪੁਲਿਸ ਕਲੀਅਰੈਂਸ",
    "port": "ਪੋਰਟ",
    "portIsRequired": "ਪੋਰਟ ਦੀ ਲੋੜ ਹੈ",
    "position": "ਸਥਿਤੀ",
    "positionIsRequired": "ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "possibilityButton": "ਸੰਭਾਵਨਾ",
    "primary": "ਪ੍ਰਾਇਮਰੀ",
    "primaryDiagnoseLabel": "ਪ੍ਰਾਇਮਰੀ ਨਿਦਾਨ",
    "primaryDiagnoseRequired": "ਪ੍ਰਾਇਮਰੀ ਨਿਦਾਨ ਦੀ ਲੋੜ ਹੈ",
    "priority": "ਤਰਜੀਹ",
    "priorityIsRequired": "ਤਰਜੀਹ ਦੀ ਲੋੜ ਹੈ",
    "privateLabel": "(ਨਿੱਜੀ)",
    "privateNote": "ਨਿੱਜੀ ਨੋਟ",
    "proceed": "ਅੱਗੇ ਵਧੋ",
    "proficiency": "ਨਿਪੁੰਨਤਾ",
    "proficiencyIsRequired": "ਮੁਹਾਰਤ ਦੀ ਲੋੜ ਹੈ",
    "profile": "ਪ੍ਰੋਫਾਈਲ",
    "profileImage": "ਪ੍ਰੋਫਾਈਲ ਚਿੱਤਰ",
    "profileImageIsRequired": "ਪ੍ਰੋਫਾਈਲ ਚਿੱਤਰ ਦੀ ਲੋੜ ਹੈ",
    "profileInformation": "ਪ੍ਰੋਫਾਈਲ ਜਾਣਕਾਰੀ",
    "profileOverview": "ਪ੍ਰੋਫਾਈਲ ਸੰਖੇਪ ਜਾਣਕਾਰੀ",
    "profileimage": "ਪ੍ਰੋਫਾਈਲ_ਚਿੱਤਰ",
    "protips": "ਪ੍ਰੋਟੀਪਸ",
    "proposedReadyTime": "ਪ੍ਰਸਤਾਵਿਤ ਤਿਆਰ ਸਮਾਂ",
    "pu": "PU",
    "puModifier": "PU ਮੋਡੀਫਾਇਰ",
    "puModifierIsRequired": "PU ਮੋਡੀਫਾਇਰ ਦੀ ਲੋੜ ਹੈ",
    "pua": "PUA",
    "publicLabel": "(ਜਨਤਕ)",
    "pull-Out": "ਪੁੱਲ - ਬਾਹਰ",
    "pullEnd": "ਖਿੱਚੋ / ਖਤਮ ਕਰੋ",
    "put": "PUT",
    "quantityLabel": "ਮਾਤਰਾ",
    "quantityRequired": "ਮਾਤਰਾ ਦੀ ਲੋੜ ਹੈ",
    "quarterdisplayname": "quarter.displayName",
    "quickFilter": "ਤੇਜ਼-ਫਿਲਟਰ",
    "quickSearch": "ਤੇਜ਼ ਖੋਜ",
    "quickSearchGuide": "🔍 ਤੇਜ਼ ਖੋਜ ਗਾਈਡ",
    "radiusIsRequired": "ਰੇਡੀਅਸ ਦੀ ਲੋੜ ਹੈ",
    "rates": "ਦਰਾਂ",
    "rawReport": "ਕੱਚੀ ਰਿਪੋਰਟ",
    "re-assign": "ਮੁੜ-ਸਾਈਨ ਕਰੋ",
    "readyNotes": "ਤਿਆਰ ਨੋਟਸ",
    "reason": "ਕਾਰਨ",
    "reasonIsRequired": "ਕਾਰਨ ਦੀ ਲੋੜ ਹੈ",
    "recurringDays": "ਆਵਰਤੀ ਦਿਨ",
    "recurringStatusRequired": "ਆਵਰਤੀ ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "refS": "ਹਵਾਲਾ #s",
    "reference": "ਹਵਾਲਾ",
    "reg": "Reg:",
    "regular": "ਨਿਯਮਤ",
    "reject": "ਅਸਵੀਕਾਰ ਕਰੋ",
    "rejected": "ਰੱਦ ਕਰ ਦਿੱਤਾ",
    "rejectedTrips": "ਰੱਦ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "relation": "ਸਬੰਧ",
    "relationIsRequired": "ਸਬੰਧ ਦੀ ਲੋੜ ਹੈ",
    "removeButton": "ਹਟਾਓ",
    "reply": "ਜਵਾਬ",
    "reports": "ਰਿਪੋਰਟਾਂ",
    "representativesignature": "ਨੁਮਾਇੰਦਾ।ਦਸਤਖਤ",
    "requiredOdometers": "ਲੋੜੀਂਦੇ ਓਡੋਮੀਟਰ",
    "rescheduleTrip": "ਯਾਤਰਾ ਨੂੰ ਮੁੜ ਨਿਯਤ ਕਰੋ",
    "resendCode": "ਕੀ ਕੋਡ ਦੁਬਾਰਾ ਭੇਜਣਾ ਹੈ?",
    "reservationNo": "ਰਿਜ਼ਰਵੇਸ਼ਨ ਨੰ:",
    "reset": "ਰੀਸੈਟ ਕਰੋ",
    "resetPassword": "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    "responseNightCode": "ਜਵਾਬ ਰਾਤ ਕੋਡ",
    "responseNightCodeIs": "ਜਵਾਬ ਨਾਈਟ ਕੋਡ ਦੀ ਲੋੜ ਹੈ",
    "rest": "ਆਰਾਮ",
    "restBreak": "ਆਰਾਮ ਬਰੇਕ",
    "return": "ਵਾਪਸੀ",
    "revenue": "ਮਾਲੀਆ",
    "reviewUrl": "URL ਦੀ ਸਮੀਖਿਆ ਕਰੋ",
    "rfLfRrLr": "(RF LF RR LR)",
    "rigNo": "ਰਿਗ ਨੰ.",
    "rigNoIsRequired": "ਰਿਗ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "ripplingId": "ਰਿਪਲਿੰਗ ਆਈ.ਡੀ",
    "ripplingIdIsRequired": "ਰਿਪਲਿੰਗ ਆਈਡੀ ਦੀ ਲੋੜ ਹੈ",
    "rode": "ਰੋਡੇ",
    "roleIsRequired": "ਭੂਮਿਕਾ ਦੀ ਲੋੜ ਹੈ",
    "roleType": "ਭੂਮਿਕਾ ਦੀ ਕਿਸਮ",
    "roleTypeIsRequired": "ਭੂਮਿਕਾ ਦੀ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "roomLabel": "ਕਮਰਾ",
    "roomRequired": "ਕਮਰਾ ਲੋੜੀਂਦਾ ਹੈ",
    "routeDetails": "ਰੂਟ ਵੇਰਵੇ",
    "routeView": "ਰੂਟ ਦ੍ਰਿਸ਼",
    "samScreening": "SAM ਸਕ੍ਰੀਨਿੰਗ",
    "save": "ਸੇਵ ਕਰੋ",
    "saveForAll": "ਸਭ ਲਈ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    "saveTemplate": "ਟੈਮਪਲੇਟ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    "scheduleShells": "ਸ਼ੈੱਲ (ਆਂ) ਨੂੰ ਤਹਿ ਕਰੋ",
    "scheduleShellsIsRequired": "ਅਨੁਸੂਚੀ ਸ਼ੈੱਲ(ਆਂ) ਦੀ ਲੋੜ ਹੈ",
    "scheduleTime": "ਸਮਾਂ ਤਹਿ ਕਰੋ",
    "scheduleTimeIsRequired": "ਸਮਾਂ ਤਹਿ ਕਰਨ ਦੀ ਲੋੜ ਹੈ",
    "scheduledTrips": "ਤਹਿ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "score": "ਸਕੋਰ",
    "scoreDetails": "ਸਕੋਰ ਵੇਰਵੇ",
    "search": "ਖੋਜ",
    "search2": "ਖੋਜ...",
    "searchCompany": "ਖੋਜ ਕੰਪਨੀ",
    "searchDriver": "ਡਰਾਈਵਰ ਖੋਜੋ",
    "searchGroup": "ਖੋਜ ਗਰੁੱਪ",
    "searchMessages": "ਸੁਨੇਹੇ ਖੋਜੋ",
    "searchVehicle": "ਵਾਹਨ ਦੀ ਖੋਜ ਕਰੋ",
    "seconds": "(ਸਕਿੰਟ)",
    "secureComplianceTrainingAckn": "ਸੁਰੱਖਿਅਤ ਪਾਲਣਾ ਸਿਖਲਾਈ ਰਸੀਦ",
    "secureType": "ਸੁਰੱਖਿਅਤ ਕਿਸਮ",
    "seeAll": "ਸਭ ਦੇਖੋ",
    "seenBy": "ਦੁਆਰਾ ਦੇਖਿਆ ਗਿਆ",
    "selectAddonItemPlaceholder": "-- ਆਈਟਮ ਚੁਣੋ --",
    "selectAll": "ਸਭ ਚੁਣੋ",
    "selectAppointmentDirectionPlaceholder": "-- ਮੁਲਾਕਾਤ ਨਿਰਦੇਸ਼ ਚੁਣੋ --",
    "selectAppointmentTypePlaceholder": "-- ਮੁਲਾਕਾਤ ਦੀ ਕਿਸਮ ਚੁਣੋ --",
    "selectAssistsPlaceholder": "-- ਸਹਾਇਕ ਚੁਣੋ --",
    "selectBreak": "ਬ੍ਰੇਕ ਚੁਣੋ",
    "selectCorporate": "ਕਾਰਪੋਰੇਟ ਚੁਣੋ",
    "selectDate": "ਮਿਤੀ ਚੁਣੋ",
    "selectDateRange": "ਮਿਤੀ ਰੇਂਜ ਚੁਣੋ",
    "selectDos": "DOS ਚੁਣੋ",
    "selectDriver": "ਡਰਾਈਵਰ ਚੁਣੋ",
    "selectDriverPlaceholder": "-- ਡਰਾਈਵਰ ਚੁਣੋ --",
    "selectFundingSource": "ਫੰਡਿੰਗ ਸਰੋਤ ਚੁਣੋ",
    "selectFundingSourcePlaceholder": "-- ਫੰਡਿੰਗ ਸਰੋਤ ਚੁਣੋ --",
    "selectGenderPlaceholder": "-- ਲਿੰਗ ਚੁਣੋ --",
    "selectLevelOfService": "ਸੇਵਾ ਦਾ ਪੱਧਰ ਚੁਣੋ",
    "selectLevelOfServicePlaceholder": "-- ਸੇਵਾ ਦਾ ਪੱਧਰ ਚੁਣੋ --",
    "selectMember": "ਮੈਂਬਰ ਚੁਣੋ",
    "selectMemberPlaceholder": "-- ਮੈਂਬਰ ਚੁਣੋ --",
    "selectModifierPlaceholder": "-- ਸੋਧਕ ਚੁਣੋ --",
    "selectNoOfEscortsPlaceholder": "-- ਐਸਕਾਰਟ ਦੀ ਸੰਖਿਆ ਚੁਣੋ --",
    "selectPayorPlaceholder": "-- ਪੇਅਰ ਚੁਣੋ --",
    "selectPrimaryDiagnosePlaceholder": "-- ਪ੍ਰਾਇਮਰੀ ਨਿਦਾਨ ਦੀ ਚੋਣ ਕਰੋ --",
    "selectServiceArea": "ਸੇਵਾ ਖੇਤਰ ਚੁਣੋ",
    "selectServiceAreaPlaceholder": "-- ਸੇਵਾ ਖੇਤਰ ਚੁਣੋ --",
    "selectSpaceType": "ਸਪੇਸ ਦੀ ਕਿਸਮ ਚੁਣੋ",
    "selectSpaceTypePlaceholder": "-- ਸਪੇਸ ਦੀ ਕਿਸਮ ਚੁਣੋ --",
    "selectStatus": "ਸਥਿਤੀ ਚੁਣੋ",
    "selectTime": "ਸਮਾਂ ਚੁਣੋ",
    "selectTimezone": "ਸਮਾਂ ਖੇਤਰ ਚੁਣੋ",
    "selectType": "ਕਿਸਮ ਚੁਣੋ",
    "selectedDriverIsRequired": "ਚੁਣੇ ਹੋਏ ਡਰਾਈਵਰ ਦੀ ਲੋੜ ਹੈ",
    "selectedServiceAreaIs": "ਚੁਣਿਆ ਹੋਇਆ ਸੇਵਾ ਖੇਤਰ ਲੋੜੀਂਦਾ ਹੈ",
    "selectedTrip": "ਚੁਣੀ ਗਈ ਯਾਤਰਾ",
    "send": "ਭੇਜੋ",
    "sendCode": "ਕੋਡ ਭੇਜੋ",
    "sendEmail": "ਈਮੇਲ ਭੇਜੋ",
    "sendOnBreak": "ਬਰੇਕ 'ਤੇ ਭੇਜੋ",
    "sentYouAnInvite": "ਤੁਹਾਨੂੰ ਜੁੜਨ ਲਈ ਇੱਕ ਸੱਦਾ ਭੇਜਿਆ ਹੈ।",
    "serviceAreaLabel": "ਸੇਵਾ ਖੇਤਰ",
    "serviceAreaRequired": "ਸੇਵਾ ਖੇਤਰ ਦੀ ਲੋੜ ਹੈ",
    "serviceAreas": "ਸੇਵਾ ਖੇਤਰ",
    "serviceAreasIsRequired": "ਸੇਵਾ ਖੇਤਰ ਲੋੜੀਂਦਾ ਹੈ",
    "serviceNameIsRequired": "ਸੇਵਾ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "serviceRepresentative": "ਸੇਵਾ ਪ੍ਰਤੀਨਿਧੀ",
    "services": "ਸੇਵਾਵਾਂ",
    "setBsr": "BSR ਸੈੱਟ ਕਰੋ",
    "setTags": "ਟੈਗ ਸੈੱਟ ਕਰੋ",
    "setiD": "ਸੇਟੀ ਡੀ:",
    "settings": "ਸੈਟਿੰਗਾਂ",
    "sexOffenderBackgroundCheck": "ਲਿੰਗ ਅਪਰਾਧੀ ਪਿਛੋਕੜ ਦੀ ਜਾਂਚ",
    "sexualHarassmentTraining": "ਜਿਨਸੀ ਪਰੇਸ਼ਾਨੀ ਦੀ ਸਿਖਲਾਈ",
    "shift": "ਸ਼ਿਫਟ:",
    "shift-End": "ਸ਼ਿਫਟ - ਅੰਤ",
    "shiftAlign": "ਸ਼ਿਫਟ ਅਲਾਈਨ",
    "shiftAlignIsRequired": "ਸ਼ਿਫਟ ਅਲਾਈਨ ਦੀ ਲੋੜ ਹੈ",
    "shiftDayWise": "ਸ਼ਿਫਟ (ਦਿਨ ਅਨੁਸਾਰ)",
    "shiftEnd": "ਸ਼ਿਫਟ ਐਂਡ",
    "shiftEndIsRequired": "ਸ਼ਿਫਟ ਐਂਡ ਦੀ ਲੋੜ ਹੈ",
    "shiftMarker": "ਸ਼ਿਫਟ ਮਾਰਕਰ",
    "shiftOverride": "ਸ਼ਿਫਟ ਓਵਰਰਾਈਡ",
    "shiftOverrideNotAvailable": "ਸ਼ਿਫਟ ਓਵਰਰਾਈਡ (ਉਪਲਬਧ ਨਹੀਂ)",
    "shiftStart": "ਸ਼ਿਫਟ ਸਟਾਰਟ",
    "shiftStartIsRequired": "ਸ਼ਿਫਟ ਸਟਾਰਟ ਦੀ ਲੋੜ ਹੈ",
    "shifts": "ਸ਼ਿਫਟ",
    "showBreak": "ਬਰੇਕ ਦਿਖਾਓ",
    "showGoogleMiles": "Google Miles ਦਿਖਾਓ",
    "showRoute": "ਰੂਟ ਦਿਖਾਓ",
    "showUnassignedTrips": "ਗੈਰ-ਜ਼ਾਈਨ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ ਦਿਖਾਓ",
    "signIn": "ਸਾਈਨ ਇਨ ਕਰੋ",
    "signInToYour": "ਆਪਣੇ ਖਾਤੇ ਵਿੱਚ ਸਾਈਨ ਇਨ ਕਰੋ",
    "signature": "ਦਸਤਖਤ",
    "signatureIsRequired": "ਦਸਤਖਤ ਦੀ ਲੋੜ ਹੈ",
    "single": "ਸਿੰਗਲ",
    "skipSignature": "ਦਸਤਖਤ ਛੱਡੋ",
    "smokeFreeVehiclesDriver": "ਧੂੰਏਂ ਤੋਂ ਮੁਕਤ ਵਾਹਨ (ਡਰਾਈਵਰ ਨੂੰ ਸਮਝਣਾ)",
    "sms": "SMS",
    "sms/dashboard": "SMS/ਡੈਸ਼ਬੋਰਡ",
    "smsRequired": "SMS ਦੀ ਲੋੜ ਹੈ",
    "sorryWeCouldntFind": "ਮਾਫ਼ ਕਰਨਾ, ਅਸੀਂ ਉਹ ਪੰਨਾ ਨਹੀਂ ਲੱਭ ਸਕੇ ਜੋ ਤੁਸੀਂ ਲੱਭ ਰਹੇ ਹੋ।",
    "sort": "ਲੜੀਬੱਧ",
    "spaceTypeLabel": "ਸਪੇਸ ਦੀ ਕਿਸਮ",
    "spaceTypeRequired": "ਸਪੇਸ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "spaceTypefileIsRequired": "ਸਪੇਸ ਕਿਸਮ (ਫਾਈਲ) ਦੀ ਲੋੜ ਹੈ",
    "spaceTypesIsRequired": "ਸਪੇਸ ਦੀ ਕਿਸਮ(ਸ) ਦੀ ਲੋੜ ਹੈ",
    "spacetypeImage": "ਸਪੇਸ ਟਾਈਪ ਚਿੱਤਰ",
    "spacetypeIsRequired": "ਸਪੇਸ ਟਾਈਪ ਦੀ ਲੋੜ ਹੈ",
    "spacetypes": "ਸਪੇਸ ਟਾਈਪ",
    "spanishLanguageLabel": "ਸਪੈਨਿਸ਼",
    "specialFare": "ਵਿਸ਼ੇਸ਼ ਕਿਰਾਇਆ",
    "specialRequests": "ਵਿਸ਼ੇਸ਼ ਬੇਨਤੀਆਂ",
    "squareImageIsRecommended": "*ਵਰਗ ਚਿੱਤਰ ਦੀ ਸਿਫ਼ਾਰਸ਼ ਕੀਤੀ ਜਾਂਦੀ ਹੈ",
    "ssl": "ssl",
    "staff": "(ਸਟਾਫ)",
    "stagingTrips": "ਸਟੇਜਿੰਗ ਯਾਤਰਾਵਾਂ",
    "stairsSteps": "ਪੌੜੀਆਂ ਦੀਆਂ ਪੌੜੀਆਂ",
    "stairsStepsIsRequired": "ਪੌੜੀਆਂ ਦੀਆਂ ਪੌੜੀਆਂ ਦੀ ਲੋੜ ਹੈ",
    "standingOrderHeader": "ਸਥਾਈ ਆਰਡਰ",
    "startDate": "ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ",
    "startDateIsRequired": "ਸ਼ੁਰੂਆਤੀ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "startTime": "ਸ਼ੁਰੂਆਤੀ ਸਮਾਂ",
    "startTimeIsRequired": "ਸ਼ੁਰੂਆਤੀ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "started": "ਸ਼ੁਰੂ ਕੀਤਾ",
    "startedAt": "ਇਸ ਸਮੇਂ ਸ਼ੁਰੂ ਹੋਇਆ:",
    "startedTimeIsRequired": "ਸ਼ੁਰੂਆਤੀ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "statReport": "ਸਟੇਟ ਰਿਪੋਰਟ",
    "stateCode": "ਰਾਜ ਕੋਡ",
    "stateCodeIsRequired": "ਰਾਜ ਕੋਡ ਲੋੜੀਂਦਾ ਹੈ",
    "stateIsRequired": "ਰਾਜ ਦੀ ਲੋੜ ਹੈ",
    "statistics": "ਅੰਕੜੇ",
    "statusActive": "ਕਿਰਿਆਸ਼ੀਲ",
    "statusInactive": "ਸਰਗਰਮ ਵਿੱਚ",
    "statusIsRequired": "ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "statusLabel": "ਸਥਿਤੀ",
    "statuses": "ਸਥਿਤੀਆਂ",
    "statuss": "ਸਥਿਤੀ(ਸਥਿਤੀਆਂ)",
    "stop": "ਰੁਕੋ",
    "stopTimeIsRequired": "ਰੁਕਣ ਦਾ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "storageInformation": "ਸਟੋਰੇਜ਼ ਜਾਣਕਾਰੀ",
    "submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
    "suggestTime": "ਸਮਾਂ ਸੁਝਾਓ",
    "suggestedTime": "ਸੁਝਾਇਆ ਸਮਾਂ",
    "support": "ਸਪੋਰਟ",
    "svc": "ਐਸ.ਵੀ.ਸੀ",
    "sweep": "ਸਵੀਪ ਕਰੋ",
    "sweepFile": "ਸਵੀਪ ਫਾਈਲ",
    "table": "ਟੇਬਲ",
    "table-user": "ਸਾਰਣੀ-ਉਪਭੋਗਤਾ",
    "takeSignature": "ਦਸਤਖਤ ਲਵੋ",
    "taxInformation": "ਟੈਕਸ ਜਾਣਕਾਰੀ",
    "taxonomyCode": "ਵਰਗੀਕਰਨ ਕੋਡ",
    "tbTest": "ਟੀਬੀ ਟੈਸਟ",
    "template": "ਟੈਂਪਲੇਟ",
    "templateIsRequired": "ਟੈਮਪਲੇਟ ਲੋੜੀਂਦਾ ਹੈ",
    "textAssistanceRequiredFor": "ਮੈਂਬਰ ਲਈ ਲਿਖਤੀ ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ।",
    "textLiveLinkTo": "ਮੈਂਬਰ ਨੂੰ ਲਾਈਵ ਲਿੰਕ ਟੈਕਸਟ ਕਰੋ",
    "thirdParty": "ਤੀਜੀ ਧਿਰ",
    "thisOperationWillComplete": "ਇਹ ਓਪਰੇਸ਼ਨ ਬੀਮਾ ਕਲੇਮ ਫਾਈਲਾਂ ਜਿਵੇਂ ਕਿ ਟ੍ਰਿਪ ਲੌਗਸ, TRF ਫਾਰਮ ਆਦਿ ਬਣਾਉਣ ਲਈ ਲੋੜੀਂਦੀ ਜਾਣਕਾਰੀ ਨੂੰ ਪੂਰਾ ਕਰੇਗਾ।",
    "threshold": "ਥ੍ਰੈਸ਼ਹੋਲਡ",
    "thresholdIsRequired": "ਥ੍ਰੈਸ਼ਹੋਲਡ ਦੀ ਲੋੜ ਹੈ",
    "timeCalibration": "ਸਮਾਂ ਕੈਲੀਬ੍ਰੇਸ਼ਨ",
    "timeFormat": "ਸਮਾਂ ਫਾਰਮੈਟ",
    "timeFormatIsRequired": "ਸਮਾਂ ਫਾਰਮੈਟ ਲੋੜੀਂਦਾ ਹੈ",
    "timeIn": "ਵਿੱਚ ਸਮਾਂ",
    "timeInAt": "'ਤੇ ਸਮਾਂ",
    "timeInIsRequired": "ਵਿੱਚ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "timeLabel": "ਸਮਾਂ",
    "timeOut": "ਸਮਾਂ ਸਮਾਪਤ",
    "timeOutIsRequired": "ਟਾਈਮ ਆਊਟ ਦੀ ਲੋੜ ਹੈ",
    "timeRequired": "ਸਮੇਂ ਦੀ ਲੋੜ ਹੈ",
    "timeZone": "ਸਮਾਂ ਖੇਤਰ",
    "timeZoneIsRequired": "ਸਮਾਂ ਖੇਤਰ ਲੋੜੀਂਦਾ ਹੈ",
    "timein": "ਟਾਈਮਇਨ",
    "timeline": "ਸਮਾਂਰੇਖਾ",
    "timelines": "ਸਮਾਂਰੇਖਾਵਾਂ",
    "times": "&times;",
    "tipStatusIsRequired": "ਟਿਪ ਸਥਿਤੀ ਦੀ ਲੋੜ ਹੈ",
    "tipTitleIsRequired": "ਟਿਪ ਸਿਰਲੇਖ ਦੀ ਲੋੜ ਹੈ",
    "tiresInformation": "ਟਾਇਰ ਜਾਣਕਾਰੀ",
    "title": "ਸਿਰਲੇਖ",
    "titleIsRequired": "ਸਿਰਲੇਖ ਲੋੜੀਂਦਾ ਹੈ",
    "tls": "tls",
    "to": "ਨੂੰ",
    "toIsRequired": "ਲਈ ਲੋੜੀਂਦਾ ਹੈ",
    "today": "ਅੱਜ",
    "toll-freeNumber": "ਟੋਲ-ਫ੍ਰੀ ਨੰਬਰ",
    "toll-freeNumberIsRequired": "ਟੋਲ-ਫ੍ਰੀ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "totalFare": "ਕੁੱਲ ਕਿਰਾਇਆ",
    "totalFareIsRequired": "ਕੁੱਲ ਕਿਰਾਇਆ ਲੋੜੀਂਦਾ ਹੈ",
    "tp": "(TP)",
    "traffic": "ਆਵਾਜਾਈ",
    "travelAndSequence": "ਯਾਤਰਾ ਅਤੇ ਕ੍ਰਮ",
    "trial": "ਮੁਕੱਦਮਾ",
    "trialEnd": "ਅਜ਼ਮਾਇਸ਼ ਸਮਾਪਤ",
    "tripAssistance": "ਯਾਤਰਾ ਸਹਾਇਤਾ",
    "tripId": "ਯਾਤਰਾ ਆਈ.ਡੀ",
    "tripIdLabel": "ਯਾਤਰਾ ਆਈ.ਡੀ",
    "tripIdRequired": "ਯਾਤਰਾ ID ਦੀ ਲੋੜ ਹੈ",
    "tripInformation": "ਯਾਤਰਾ ਦੀ ਜਾਣਕਾਰੀ",
    "tripLogs": "ਟ੍ਰਿਪ ਲੌਗਸ",
    "tripQuota": "ਯਾਤਰਾ ਕੋਟਾ",
    "tripQuotaIsRequired": "ਯਾਤਰਾ ਕੋਟਾ ਲੋੜੀਂਦਾ ਹੈ",
    "tripReport": "ਯਾਤਰਾ ਦੀ ਰਿਪੋਰਟ",
    "tripRoute": "ਯਾਤਰਾ ਦਾ ਰਸਤਾ",
    "tripS": "ਯਾਤਰਾ(ਸਫ਼ਰਾਂ)",
    "tripSequenceLate": "ਯਾਤਰਾ ਕ੍ਰਮ (ਦੇਰ ਨਾਲ)",
    "tripSequenceOnTime": "ਯਾਤਰਾ ਕ੍ਰਮ (ਸਮੇਂ 'ਤੇ)",
    "tripStatus": "ਯਾਤਰਾ ਸਥਿਤੀ",
    "tripWise": "ਟ੍ਰਿਪ ਵਾਈਜ਼",
    "trips": "ਯਾਤਰਾਵਾਂ",
    "tripsAdjustmentImportant": "ਟ੍ਰਿਪ ਐਡਜਸਟਮੈਂਟ (ਬੈਂਕਿੰਗ ਤੋਂ ਪਹਿਲਾਂ ਮਹੱਤਵਪੂਰਨ)",
    "tripsFile": "ਟ੍ਰਿਪ ਫਾਈਲ",
    "tripsFileIsRequired": "ਟ੍ਰਿਪ ਫਾਈਲ ਦੀ ਲੋੜ ਹੈ",
    "tripsItinerary": "ਯਾਤਰਾਵਾਂ ਦੀ ਯਾਤਰਾ",
    "tripsMapDashboard": "ਯਾਤਰਾਵਾਂ ਦਾ ਨਕਸ਼ਾ ਡੈਸ਼ਬੋਰਡ",
    "type": "ਟਾਈਪ ਕਰੋ",
    "typeAMessage": "ਇੱਕ ਸੁਨੇਹਾ ਟਾਈਪ ਕਰੋ .....",
    "un-selectAll": "ਸਭ ਨੂੰ ਅਣ-ਚੁਣੋ",
    "unassign": "ਅਸਾਈਨ ਕਰੋ",
    "unassigned": "ਅਸਾਈਨ ਨਹੀਂ ਕੀਤਾ ਗਿਆ",
    "unassignedCancelled": "ਅਸਾਈਨ ਕੀਤਾ ਰੱਦ ਕੀਤਾ ਗਿਆ",
    "unassignedTrips": "ਅਸਾਈਨ ਨਹੀਂ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "unconfirm": "ਅਸਪਸ਼ਟ",
    "undo": "ਅਣਡੂ",
    "unknown": "ਅਗਿਆਤ",
    "unloadTimeIsRequired": "ਅਨਲੋਡ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "unscheduled": "[ਅਨਸੂਚਿਤ]",
    "upBaseAddress": "ਉੱਪਰ ਅਧਾਰ ਪਤਾ",
    "updateAssists": "ਅੱਪਡੇਟ ਅਸਿਸਟ",
    "updateButton": "ਅੱਪਡੇਟ ਕਰੋ",
    "updateStatus": "ਅੱਪਡੇਟ ਸਥਿਤੀ",
    "uploadAFile": "ਇੱਕ ਫ਼ਾਈਲ ਅੱਪਲੋਡ ਕਰੋ",
    "uploadAnImage": "ਇੱਕ ਚਿੱਤਰ ਅੱਪਲੋਡ ਕਰੋ",
    "uploadJpegJpgOr": ".jpeg, .jpg ਜਾਂ .png ਫ਼ਾਈਲ ਅੱਪਲੋਡ ਕਰੋ",
    "uploadTxtFile": ".txt ਫ਼ਾਈਲ ਅੱਪਲੋਡ ਕਰੋ",
    "uploadXlsxXlsOr": ".xlsx, .xls ਜਾਂ .csv ਫ਼ਾਈਲ ਅੱਪਲੋਡ ਕਰੋ",
    "urduLanguageLabel": "ਉਰਦੂ",
    "url": "URL",
    "useAPermanentAddress": "ਇੱਕ ਸਥਾਈ ਪਤੇ ਦੀ ਵਰਤੋਂ ਕਰੋ ਜਿੱਥੇ ਤੁਸੀਂ ਮੇਲ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹੋ।",
    "useAuthenticSignatures": "ਪ੍ਰਮਾਣਿਕ ਦਸਤਖਤਾਂ ਦੀ ਵਰਤੋਂ ਕਰੋ।",
    "useMemberPermanentAddress": "ਮੈਂਬਰ ਦਾ ਸਥਾਈ ਪਤਾ ਵਰਤੋ ਜਿੱਥੇ ਉਹ ਮੇਲ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦਾ ਹੈ।",
    "useSettingAriaLabel": "ਸੈਟਿੰਗ ਦੀ ਵਰਤੋਂ ਕਰੋ",
    "user": "ਉਪਭੋਗਤਾ",
    "user-image": "ਉਪਭੋਗਤਾ-ਚਿੱਤਰ",
    "user-img": "user-img",
    "userPhoto": "ਉਪਭੋਗਤਾ ਫੋਟੋ",
    "username": "ਯੂਜ਼ਰਨੇਮ",
    "usernameIsRequired": "ਯੂਜ਼ਰਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
    "users": "ਉਪਭੋਗਤਾ",
    "usingTheBelowForm": "ਨਵੇਂ ਬ੍ਰੋਕਰ ਕੌਂਫਿਗਰੇਸ਼ਨ ਨੂੰ ਜੋੜਨ ਲਈ ਹੇਠਾਂ ਦਿੱਤੇ ਫਾਰਮ ਦੀ ਵਰਤੋਂ ਕਰਨਾ",
    "usingTheBelowForm2": "ਨਵੀਂ ਈਮੇਲ ਕੌਂਫਿਗਰੇਸ਼ਨ ਜੋੜਨ ਲਈ ਹੇਠਾਂ ਦਿੱਤੇ ਫਾਰਮ ਦੀ ਵਰਤੋਂ ਕਰਨਾ",
    "v1": "V1",
    "v2": "V2",
    "v3": "V3",
    "validityRange": "ਵੈਧਤਾ ਸੀਮਾ",
    "validityRangeIsRequired": "ਵੈਧਤਾ ਸੀਮਾ ਦੀ ਲੋੜ ਹੈ",
    "vehicle": "ਵਾਹਨ",
    "vehicleDecalNumberIs": "ਵਾਹਨ ਦਾ ਡੈਕਲ ਨੰਬਰ ਲੋੜੀਂਦਾ ਹੈ",
    "vehicleGarage": "ਵਾਹਨ ਗੈਰੇਜ",
    "vehicleIdentificationNumberI": "ਵਾਹਨ ਪਛਾਣ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "vehicleImageBack": "ਵਾਹਨ ਚਿੱਤਰ ਪਿੱਛੇ",
    "vehicleImageFront": "ਵਾਹਨ ਚਿੱਤਰ ਸਾਹਮਣੇ",
    "vehicleImageLeft": "ਵਾਹਨ ਚਿੱਤਰ ਖੱਬੇ",
    "vehicleImageRight": "ਵਾਹਨ ਚਿੱਤਰ ਦਾ ਸੱਜਾ",
    "vehicleInspectionInPast": "ਲੁੱਕਬੈਕ ਮਿਆਦ ਦੇ ਨਾਲ ਪਿਛਲੇ 12 ਮਹੀਨਿਆਂ ਵਿੱਚ ਵਾਹਨਾਂ ਦੀ ਜਾਂਚ।",
    "vehicleMakeIsRequired": "ਵਾਹਨ ਬਣਾਉਣ ਦੀ ਲੋੜ ਹੈ",
    "vehicleRecordCheckDot": "ਵਾਹਨ ਰਿਕਾਰਡ ਦੀ ਜਾਂਚ (DOT MVR)",
    "vehicleRecordCheckStandard": "ਵਾਹਨ ਰਿਕਾਰਡ ਦੀ ਜਾਂਚ (ਮਿਆਰੀ ਜਾਂਚ)",
    "vehicleServiceNumberIs": "ਵਾਹਨ ਸੇਵਾ ਨੰਬਰ ਦੀ ਲੋੜ ਹੈ",
    "vehicleTypeIsRequired": "ਵਾਹਨ ਦੀ ਕਿਸਮ ਦੀ ਲੋੜ ਹੈ",
    "vehicleWise": "ਵਾਹਨ ਬੁੱਧੀਮਾਨ",
    "vehiclesFleet": "ਵਾਹਨ/ਫਲੀਟ",
    "verifyCode": "ਕੋਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    "viewRoute": "ਰੂਟ ਦੇਖੋ",
    "viewTripsOnly": "ਸਿਰਫ਼ ਯਾਤਰਾਵਾਂ ਦੇਖੋ",
    "vin": "VIN",
    "vinIsRequired": "VIN ਲੋੜੀਂਦਾ ਹੈ",
    "violationIsRequired": "ਉਲੰਘਣਾ ਦੀ ਲੋੜ ਹੈ",
    "violationSets": "ਉਲੰਘਣਾ ਸੈੱਟ",
    "vipExpiryDate": "VIP ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ",
    "vipExpiryDateIs": "VIP ਦੀ ਮਿਆਦ ਪੁੱਗਣ ਦੀ ਮਿਤੀ ਲੋੜੀਂਦੀ ਹੈ",
    "vipLabel": "ਵੀ.ਆਈ.ਪੀ",
    "vipMembers": "ਵੀਆਈਪੀ ਮੈਂਬਰ",
    "virginia": "ਵਰਜੀਨੀਆ",
    "visit": "ਫੇਰੀ",
    "voicemail": "ਵੌਇਸਮੇਲ",
    "waitTime": "ਉਡੀਕ ਸਮਾਂ",
    "waitTimeCode": "ਉਡੀਕ ਸਮਾਂ ਕੋਡ",
    "waitTimeCodeIs": "ਉਡੀਕ ਸਮਾਂ ਕੋਡ ਲੋੜੀਂਦਾ ਹੈ",
    "waitTimeIsRequired": "ਉਡੀਕ ਸਮਾਂ ਲੋੜੀਂਦਾ ਹੈ",
    "wandererRisk": "ਵੈਂਡਰਰ ਜੋਖਮ",
    "warning": "ਚੇਤਾਵਨੀ",
    "weekendNightCode": "ਵੀਕੈਂਡ ਨਾਈਟ ਕੋਡ",
    "weekendNightCodeIs": "ਵੀਕੈਂਡ ਨਾਈਟ ਕੋਡ ਦੀ ਲੋੜ ਹੈ",
    "weeklyFee": "ਹਫਤਾਵਾਰੀ ਫੀਸ",
    "weeklyFeeIsRequired": "ਹਫਤਾਵਾਰੀ ਫੀਸ ਦੀ ਲੋੜ ਹੈ",
    "weightLabel": "ਭਾਰ",
    "weightRequired": "ਭਾਰ ਦੀ ਲੋੜ ਹੈ",
    "wheelchairRampInformation": "ਵ੍ਹੀਲਚੇਅਰ ਰੈਂਪ ਜਾਣਕਾਰੀ",
    "wheelchairSecurementTraining": "ਵ੍ਹੀਲਚੇਅਰ ਸੁਰੱਖਿਆ ਸਿਖਲਾਈ (EXP)",
    "widthIsRequired": "ਚੌੜਾਈ ਦੀ ਲੋੜ ਹੈ",
    "willCall": "ਵਿਲਕਾਲ",
    "willCall2359": "ਕਾਲ ਕਰੇਗਾ (23:59)",
    "willCallActivated": "ਕਾਲ ਨੂੰ ਐਕਟੀਵੇਟ ਕੀਤਾ ਜਾਵੇਗਾ",
    "willCallBracket": "[ਕਾਲ ਕਰੇਗਾ]",
    "willCallLabel": "ਕਾਲ ਕਰਨਗੇ",
    "willCallTrip": "ਕਾਲ ਟ੍ਰਿਪ ਕਰਨਗੇ",
    "wmrNumber": "WMR ਨੰਬਰ",
    "wmrNumberIsRequired": "WMR ਨੰਬਰ ਲੋੜੀਂਦਾ ਹੈ",
    "writeYourCommentHere": "ਆਪਣੀ ਟਿੱਪਣੀ ਇੱਥੇ ਲਿਖੋ...",
    "yamsolLlc": "YAMSOL LLC",
    "year": "ਸਾਲ",
    "yearIsRequired": "ਸਾਲ ਦੀ ਲੋੜ ਹੈ",
    "yes": "ਹਾਂ",
    "yourCompany": "ਤੁਹਾਡੀ ਕੰਪਨੀ",
    "yourLicenseIsGoing": "ਤੁਹਾਡੇ ਲਾਇਸੰਸ ਦੀ ਮਿਆਦ 22/11/2020 ਨੂੰ ਖਤਮ ਹੋਣ ਜਾ ਰਹੀ ਹੈ। ਕਿਸੇ ਵੀ ਅਸੁਵਿਧਾ ਤੋਂ ਬਚਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਹੂਜ਼ੀਅਰ ਟਰਾਂਸਪੋਰਟੇਸ਼ਨ 'ਤੇ ਆਪਣੇ ਲਾਇਸੈਂਸ ਨੂੰ ਰੀਨਿਊ ਅਤੇ ਅੱਪਡੇਟ ਕਰੋ।",
    "zipCode": "ਜ਼ਿਪ ਕੋਡ",
    "zipCodeIsRequired": "ਜ਼ਿਪ ਕੋਡ ਲੋੜੀਂਦਾ ਹੈ",
    "zipIsRequired": "ਜ਼ਿਪ ਦੀ ਲੋੜ ਹੈ",
    "zoneForIsRequired": "ਲਈ ਜ਼ੋਨ ਲੋੜੀਂਦਾ ਹੈ",
    "zoneName": "ਜ਼ੋਨ ਦਾ ਨਾਮ",
    "zones": "ਜ਼ੋਨ",
    "zoom": "ਜ਼ੂਮ",
    "id": "ID",
    "escort": "ਐਸਕਾਰਟ",
    "spRate": "ਐਸ.ਪੀ. ਦਰ",
    "estFare": "ਈ.ਐਸ.ਟੀ. ਕਿਰਾਇਆ",
    "createdTime": "ਬਣਾਇਆ ਸਮਾਂ",
    "authNumber": "ਪ੍ਰਮਾਣਿਕਤਾ ਨੰਬਰ",
    "appointmentTypes": "ਮੁਲਾਕਾਤ ਦੀ ਕਿਸਮ",
    "dvNotes": "ਡੀਵੀ ਨੋਟਸ",
    "source": "ਸਰੋਤ",
    "trackingNo": "ਟਰੈਕਿੰਗ ਨੰ.",
    "roleOrSource": "ਭੂਮਿਕਾ/ਸਰੋਤ",
    "staffManager": "ਸਟਾਫ ਮੈਨੇਜਰ",
    "mobileNumber": "ਮੋਬਾਈਲ ਨੰਬਰ",
    "updatedAt": "'ਤੇ ਅੱਪਡੇਟ ਕੀਤਾ",
    "createdAt": "ਵਿਖੇ ਬਣਾਇਆ ਗਿਆ",
    "version": "ਸੰਸਕਰਣ",
    "shiftLabel": "ਸ਼ਿਫਟ",
    "role": "ਭੂਮਿਕਾ",
    "puTime": "ਪੀਯੂ ਟਾਈਮ",
    "doTime": "DO ਸਮਾਂ",
    "puDate": "PU ਮਿਤੀ",
    "doDate": "DO ਮਿਤੀ",
    "memberInfo": "ਮੈਂਬਰ ਜਾਣਕਾਰੀ",
    "facilityVeh": "ਸਹੂਲਤ - Veh",
    "noMemberName": "ਨੰਬਰ/ਮੈਂਬਰ ਦਾ ਨਾਮ",
    "dosLabel": "DOS",
    "losLabel": "LOS",
    "pickupTime": "ਪਿਕਅੱਪ ਸਮਾਂ",
    "dropoffTime": "ਡ੍ਰੌਪਆਫ ਟਾਈਮ",
    "mileage": "ਮਾਈਲੇਜ",
    "reservationNoLabel": "ਰਿਜ਼ਰਵੇਸ਼ਨ ਨੰ.",
    "claimed": "ਦਾਅਵਾ ਕੀਤਾ",
    "onboardStatus": "ਆਨਬੋਰਡ ਸਥਿਤੀ",
    "insurance": "ਬੀਮਾ",
    "loadTime": "ਲੋਡ ਸਮਾਂ",
    "unloadTime": "ਅਨਲੋਡ ਸਮਾਂ",
    "totalTrips": "ਕੁੱਲ ਯਾਤਰਾਵਾਂ",
    "totalIntake": "ਕੁੱਲ ਦਾਖਲਾ",
    "serviceCharges": "ਸੇਵਾ ਖਰਚੇ",
    "companyIntake": "ਕੰਪਨੀ ਇਨਟੇਕ",
    "remainingAmount": "ਬਾਕੀ ਰਕਮ",
    "cashPayment": "ਨਕਦ ਭੁਗਤਾਨ",
    "creditPayment": "ਕ੍ਰੈਡਿਟ ਭੁਗਤਾਨ",
    "adjustedAmount": "ਵਿਵਸਥਿਤ ਰਕਮ",
    "balance": "ਸੰਤੁਲਨ",
    "driverEarnings": "ਡਰਾਈਵਰ ਦੀ ਕਮਾਈ",
    "earnings": "ਕਮਾਈਆਂ",
    "cash": "ਨਕਦ",
    "credit": "ਕ੍ਰੈਡਿਟ",
    "adjusted": "ਐਡਜਸਟ ਕੀਤਾ",
    "total": "ਕੁੱਲ",
    "early": "ਛੇਤੀ",
    "onTime": "ਸਮੇਂ 'ਤੇ",
    "late": "ਲੇਟ",
    "earlyTimeScore": "ਅਰਲੀ ਟਾਈਮ ਸਕੋਰ",
    "onTimeScore": "ਟਾਈਮ ਸਕੋਰ 'ਤੇ",
    "lateTimeScore": "ਲੇਟ ਟਾਈਮ ਸਕੋਰ",
    "actualOnTimeScore": "ਸਮੇਂ ਦੇ ਸਕੋਰ 'ਤੇ ਅਸਲ",
    "aptTime": "APT ਸਮਾਂ",
    "arrivedTime": "ਪਹੁੰਚਣ ਦਾ ਸਮਾਂ",
    "message": "ਸੁਨੇਹਾ",
    "error": "ਗਲਤੀ",
    "sentDate": "ਭੇਜਣ ਦੀ ਮਿਤੀ",
    "createdDate": "ਬਣਾਉਣ ਦੀ ਮਿਤੀ",
    "memberId": "ਮੈਂਬਰ ਆਈ.ਡੀ",
    "otpStatus": "OTP ਸਥਿਤੀ",
    "otpMinutes": "OTP ਮਿੰਟ",
    "oneHourViolation": "1-ਘੰਟੇ ਦੀ ਉਲੰਘਣਾ",
    "filePath": "ਫਾਈਲ ਮਾਰਗ",
    "mrnLabel": "ਮੈਂਬਰ ਰਿਕਾਰਡ ਨੰਬਰ (MRN)",
    "timestamps": "ਟਾਈਮ ਸਟਪਸ",
    "trackId": "ਟਰੈਕ ਆਈ.ਡੀ",
    "location": "ਟਿਕਾਣਾ",
    "report": "ਰਿਪੋਰਟ",
    "currentMileage": "ਮੌਜੂਦਾ ਮਾਈਲੇਜ",
    "inspectedBy": "ਵੱਲੋਂ ਨਿਰੀਖਣ ਕੀਤਾ ਗਿਆ",
    "inspectionCenter": "ਨਿਰੀਖਣ ਕੇਂਦਰ",
    "result": "ਨਤੀਜਾ",
    "passed": "ਪਾਸ ਕੀਤਾ",
    "failed": "ਅਸਫਲ",
    "dateCorrected": "ਮਿਤੀ ਠੀਕ ਕੀਤੀ ਗਈ",
    "frontDriverPassengerCompartment": "ਫਰੰਟ ਡਰਾਈਵਰ/ਪੈਸੇਂਜਰ ਕੰਪਾਰਟਮੈਂਟ",
    "patientCompartment": "ਮਰੀਜ਼ ਕੰਪਾਰਟਮੈਂਟ",
    "exteriorVehicle": "ਬਾਹਰੀ ਵਾਹਨ",
    "underHoodCompartment": "ਹੁੱਡ / ਕੰਪਾਰਟਮੈਂਟ ਦੇ ਹੇਠਾਂ",
    "fluidsEngine": "ਤਰਲ / ਇੰਜਣ",
    "brakeTest": "ਬ੍ਰੇਕ ਟੈਸਟ",
    "tiresWheels": "ਟਾਇਰ / ਪਹੀਏ",
    "brakes": "ਬ੍ਰੇਕਸ",
    "bodyFrame": "ਸਰੀਰ ਅਤੇ ਫਰੇਮ",
    "fuelSystem": "ਬਾਲਣ ਸਿਸਟਮ",
    "exhaustSystem": "ਐਕਸਹਾਸਟ ਸਿਸਟਮ",
    "cost": "ਲਾਗਤ",
    "category": "ਸ਼੍ਰੇਣੀ",
    "shiftTime": "ਸ਼ਿਫਟ ਸਮਾਂ",
    "timeInTimeOut": "ਟਾਈਮ ਇਨ/ਟਾਈਮ ਆਊਟ",
    "mealTakenDue": "ਲਿਆ ਭੋਜਨ/ਬਕਾਇਆ",
    "restTakenDue": "ਅਰਾਮ ਲਿਆ/ਬਕਾਇਆ",
    "workingHours": "ਕੰਮ ਦੇ ਘੰਟੇ",
    "breakHours": "ਬਰੇਕ ਘੰਟੇ",
    "loadedMilesRate": "ਲੋਡ ਕੀਤੇ ਮੀਲ ਦੀ ਦਰ",
    "deadMilesRate": "ਡੈੱਡ ਮੀਲਜ਼ ਰੇਟ",
    "account": "ਖਾਤਾ",
    "amount": "ਰਕਮ",
    "approxDo": "~ ਕਰੋ",
    "approxPu": "~ PU",
    "approxTimeLabel": "ਅੰਦਾਜ਼ਨ ਸਮਾਂ",
    "approxPuLabel": "ਅੰਦਾਜ਼ਨ ਪਿਕਅੱਪ",
    "approxDoLabel": "ਅੰਦਾਜ਼ਨ ਡਰਾਪ-ਆਫ",
    "currentTrip": "ਮੌਜੂਦਾ ਯਾਤਰਾ",
    "appt": "ਐਪ",
    "arrive": "ਪਹੁੰਚੋ",
    "arriveDist": "ਪਹੁੰਚੋ ਜਿਲਾ",
    "availability": "ਉਪਲਬਧਤਾ",
    "breaksAck": "Ack ਤੋੜਦਾ ਹੈ।",
    "breaksDue": "ਬਰੇਕ ਕਾਰਨ",
    "breaksTaken": "ਬਰੇਕ ਲਏ",
    "bucket": "ਬਾਲਟੀ",
    "bumped": "ਟਕਰਾਇਆ",
    "cads": "ਕੈਡਸ",
    "cancelCharge": "ਚਾਰਜ ਰੱਦ ਕਰੋ",
    "cancelledTrips": "ਰੱਦ ਕੀਤੀਆਂ ਯਾਤਰਾਵਾਂ",
    "changeReason": "ਕਾਰਨ ਬਦਲੋ",
    "claimAmount": "ਦਾਅਵੇ ਦੀ ਰਕਮ",
    "claimId": "ਦਾਅਵਾ ID",
    "claimPaymentAmount": "ਭੁਗਤਾਨ ਦੀ ਰਕਮ ਦਾ ਦਾਅਵਾ ਕਰੋ",
    "company": "ਕੰਪਨੀ",
    "companyIntakeAfterThreshold": "ਥ੍ਰੈਸ਼ਹੋਲਡ ਤੋਂ ਬਾਅਦ ਕੰਪਨੀ ਦਾ ਦਾਖਲਾ",
    "completedTrips": "ਯਾਤਰਾਵਾਂ ਪੂਰੀਆਂ ਕੀਤੀਆਂ",
    "components": "ਕੰਪੋਨੈਂਟਸ",
    "dateLabel": "ਮਿਤੀ",
    "day": "ਦਿਨ",
    "declined": "ਅਸਵੀਕਾਰ ਕੀਤਾ",
    "distDiff": "ਜਿਲਾ. ਅੰਤਰ.",
    "distance": "ਦੂਰੀ",
    "distanceViolet": "ਦੂਰੀ ਵਾਇਲੇਟ.",
    "doAddress": "DO ਪਤਾ",
    "driverIntakeAfterThreshold": "ਥ੍ਰੈਸ਼ਹੋਲਡ ਤੋਂ ਬਾਅਦ ਡਰਾਈਵਰ ਦਾ ਦਾਖਲਾ",
    "dropoffDiff": "ਡ੍ਰੌਪਆਫ ਡਿਫ.",
    "duration": "ਮਿਆਦ",
    "engaged": "ਰੁਝੇ ਹੋਏ",
    "eta": "ETA",
    "events": "ਸਮਾਗਮ",
    "fee": "ਫੀਸ",
    "flatFee": "ਫਲੈਟ ਫੀਸ",
    "fromTime": "ਸਮੇਂ ਤੋਂ",
    "group": "ਸਮੂਹ",
    "ignored": "ਅਣਡਿੱਠ ਕੀਤਾ",
    "lateReason": "ਦੇਰ ਕਾਰਨ",
    "loadUnloadTime": "ਲੋਡ/ਅਨਲੋਡ ਸਮਾਂ",
    "loadedMiles": "ਲੋਡ ਕੀਤੇ ਮੀਲ",
    "maxFactor": "ਅਧਿਕਤਮ ਕਾਰਕ",
    "minimumFare": "ਘੱਟੋ-ਘੱਟ ਕਿਰਾਇਆ",
    "netProfit": "ਸ਼ੁੱਧ ਲਾਭ",
    "newDist": "ਨਵੀਂ ਜਿਲ੍ਹਾ.",
    "noOfTrips": "ਯਾਤਰਾਵਾਂ ਦੀ ਸੰਖਿਆ",
    "noShowCharge": "ਕੋਈ ਸ਼ੋਅ ਚਾਰਜ ਨਹੀਂ",
    "odometerStartEnd": "ਓਡੋਮੀਟਰ ਸਟਾਰਟ-ਐਂਡ",
    "onboardViolet": "ਆਨਬੋਰਡ ਵਾਇਲੇਟ।",
    "otherViolet": "ਹੋਰ ਵਾਇਲੇਟ.",
    "outgoings": "ਆਊਟਗੋਇੰਗ",
    "passedFailed": "ਪਾਸ/ਫੇਲ",
    "patientName": "ਮਰੀਜ਼ ਦਾ ਨਾਮ",
    "pdOrder": "ਪੀ/ਡੀ ਆਰਡਰ",
    "perform": "ਪਰਫਾਰਮ ਕਰੋ",
    "performDist": "ਪ੍ਰਦਰਸ਼ਨ ਜਿਲਾ",
    "phone": "ਫ਼ੋਨ",
    "phoneNo": "ਫੋਨ ਨੰ.",
    "pickupDiff": "ਪਿਕਅੱਪ ਡਿਫ.",
    "platformCharges": "ਪਲੇਟਫਾਰਮ ਖਰਚੇ:",
    "preDist": "ਪ੍ਰੀ ਜਿਲਾ.",
    "price": "ਕੀਮਤ",
    "puAddress": "PU ਦਾ ਪਤਾ",
    "puDoAddress": "PU - DO ਪਤਾ",
    "remaining": "ਬਾਕੀ",
    "restHours": "ਆਰਾਮ ਦੇ ਘੰਟੇ",
    "returned": "ਵਾਪਸ ਆ ਗਿਆ",
    "rigHash": "ਰਿਗ#",
    "rigType": "ਰਿਗ ਦੀ ਕਿਸਮ",
    "service": "ਸੇਵਾ",
    "serviceDate": "ਸੇਵਾ ਦੀ ਮਿਤੀ",
    "sr": "ਸ੍ਰ.",
    "srHash": "Sr#",
    "status": "ਸਥਿਤੀ",
    "timeDifference": "ਸਮੇਂ ਦਾ ਅੰਤਰ",
    "timeStamps": "ਟਾਈਮ ਸਟਪਸ",
    "timeWise": "ਸਮਾਂ ਸਿਆਣਾ",
    "tip": "ਟਿਪ",
    "toTime": "ਸਮੇਂ ਲਈ",
    "toll": "ਟੋਲ",
    "totalDeadMileRate": "ਕੁੱਲ ਡੈੱਡ ਮੀਲ ਦੀ ਦਰ",
    "totalEarning": "ਕੁੱਲ ਕਮਾਈ",
    "totalEarningsColon": "ਕੁੱਲ ਕਮਾਈਆਂ:",
    "totalLoadedMileRate": "ਕੁੱਲ ਲੋਡ ਕੀਤੇ ਮੀਲ ਦੀ ਦਰ",
    "travel": "ਯਾਤਰਾ",
    "tripEarnings": "ਯਾਤਰਾ ਦੀਆਂ ਕਮਾਈਆਂ",
    "willCallStatus": "ਸਥਿਤੀ ਨੂੰ ਕਾਲ ਕਰੇਗਾ",
    "adjustTrips": "ਯਾਤਰਾਵਾਂ ਨੂੰ ਵਿਵਸਥਿਤ ਕਰੋ",
    "amendmentReq": "ਸੋਧ ਦੀ ਮੰਗ",
    "assistRequired": "ਸਹਾਇਤਾ ਦੀ ਲੋੜ ਹੈ?",
    "associateTo": "ਨੂੰ ਐਸੋਸੀਏਟ",
    "broker": "ਦਲਾਲ",
    "calculate": "ਗਣਨਾ ਕਰੋ",
    "clientIdMemberId": "ਕਲਾਇੰਟ ID / ਮੈਂਬਰ ID / MA# / AHCCCS#",
    "displayName": "ਡਿਸਪਲੇ ਨਾਮ",
    "documentExpiry": "ਦਸਤਾਵੇਜ਼ ਦੀ ਮਿਆਦ ਸਮਾਪਤੀ",
    "driverGrievanceReport": "ਡਰਾਈਵਰ ਸ਼ਿਕਾਇਤ ਰਿਪੋਰਟ",
    "driverSignature": "ਡਰਾਈਵਰ ਦੇ ਦਸਤਖਤ",
    "generalInformation": "ਆਮ ਜਾਣਕਾਰੀ",
    "generateReport": "ਰਿਪੋਰਟ ਤਿਆਰ ਕਰੋ",
    "googleApproximation": "ਗੂਗਲ ਅਨੁਮਾਨ",
    "localApproximation": "ਸਥਾਨਕ ਅਨੁਮਾਨ",
    "ltiReport": "LTI ਰਿਪੋਰਟ",
    "markConfirmed": "ਮਾਰਕ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਗਈ",
    "markReady": "ਮਾਰਕ ਤਿਆਰ",
    "unmarkReady": "ਤਿਆਰ ਦਾ ਨਿਸ਼ਾਨ ਹਟਾਓ",
    "markUnassigned": "ਅਸਾਈਨ ਕੀਤੇ ਦੀ ਨਿਸ਼ਾਨਦੇਹੀ ਕਰੋ",
    "markVoicemail": "ਵੌਇਸਮੇਲ ਮਾਰਕ ਕਰੋ",
    "milesReport": "ਮੀਲਜ਼ ਰਿਪੋਰਟ",
    "modifierTwo": "ਸੋਧਕ ਦੋ",
    "otherReason": "ਹੋਰ ਕਾਰਨ",
    "partialEdit": "ਅੰਸ਼ਕ ਸੰਪਾਦਨ",
    "plusAdd": "+ ਸ਼ਾਮਲ ਕਰੋ",
    "rating": "ਰੇਟਿੰਗ",
    "rawTripSummary": "ਕੱਚੀ ਯਾਤਰਾ ਦਾ ਸੰਖੇਪ",
    "receiverEmail": "ਪ੍ਰਾਪਤਕਰਤਾ ਈਮੇਲ",
    "state": "ਰਾਜ",
    "tripsReport": "ਯਾਤਰਾਵਾਂ ਦੀ ਰਿਪੋਰਟ",
    "update": "ਅੱਪਡੇਟ ਕਰੋ",
    "showing": "ਦਿਖਾ ਰਿਹਾ ਹੈ",
    "entries": "ਇੰਦਰਾਜ਼",
    "enterInPercent": "% ਵਿੱਚ ਦਾਖਲ ਹੋਵੋ",
    "enterInPercentage": "ਪ੍ਰਤੀਸ਼ਤ ਵਿੱਚ ਦਾਖਲ ਕਰੋ",
    "selectCorporatePlaceholder": "-- ਕਾਰਪੋਰੇਟ ਚੁਣੋ --",
    "grievance": "ਸ਼ਿਕਾਇਤ",
    "itemLost": "ਆਈਟਮ ਗੁੰਮ ਗਈ",
    "generalShift": "ਜਨਰਲ ਸ਼ਿਫਟ",
    "addCorporate": "ਕਾਰਪੋਰੇਟ ਸ਼ਾਮਲ ਕਰੋ",
    "addCompanies": "ਕੰਪਨੀਆਂ ਸ਼ਾਮਲ ਕਰੋ",
    "Accidental Reports": "ਦੁਰਘਟਨਾ ਦੀਆਂ ਰਿਪੋਰਟਾਂ",
    "Addons": "ਐਡਆਨ",
    "Announcements": "ਘੋਸ਼ਣਾਵਾਂ",
    "Appointment Types": "ਮੁਲਾਕਾਤ ਦੀਆਂ ਕਿਸਮਾਂ",
    "Billing": "ਬਿਲਿੰਗ",
    "Business Reports": "ਕਾਰੋਬਾਰੀ ਰਿਪੋਰਟਾਂ",
    "CheckList": "ਚੈੱਕਲਿਸਟ",
    "Dashboard": "ਡੈਸ਼ਬੋਰਡ",
    "Availability": "ਉਪਲਬਧਤਾ",
    "Dirt Road": "ਕੱਚੀ ਸੜਕ",
    "Driver Alerts": "ਡਰਾਈਵਰ ਚੇਤਾਵਨੀਆਂ",
    "Driver Expense": "ਡਰਾਈਵਰ ਖਰਚਾ",
    "Driver Score": "ਡਰਾਈਵਰ ਸਕੋਰ",
    "Driver Wise": "ਡਰਾਈਵਰ ਸਿਆਣਾ",
    "EDI 835": "EDI 835",
    "Earnings": "ਕਮਾਈਆਂ",
    "Extras": "ਵਾਧੂ",
    "Fleet": "ਫਲੀਟ",
    "Grievance / Item Lost": "ਸ਼ਿਕਾਇਤ / ਵਸਤੂ ਗੁੰਮ ਗਈ",
    "Helping Material": "ਮਦਦ ਕਰਨ ਵਾਲੀ ਸਮੱਗਰੀ",
    "Invoice": "ਚਲਾਨ",
    "Itineries": "ਯਾਤਰਾਵਾਂ",
    "Maintenance": "ਰੱਖ-ਰਖਾਅ",
    "Manifest": "ਪ੍ਰਗਟ",
    "Manual": "ਮੈਨੁਅਲ",
    "Modifier Codes": "ਸੋਧਕ ਕੋਡ",
    "Nemt Pro Tips": "Nemt ਪ੍ਰੋ ਸੁਝਾਅ",
    "Operations": "ਸੰਚਾਲਨ",
    "Outbounding": "ਆਊਟਬਾਉਂਡਿੰਗ",
    "Planner": "ਯੋਜਨਾਕਾਰ",
    "Primary Diagnosis": "ਪ੍ਰਾਇਮਰੀ ਨਿਦਾਨ",
    "Pro Tips": "ਪ੍ਰੋ ਸੁਝਾਅ",
    "Push to Talk": "ਗੱਲ ਕਰਨ ਲਈ ਧੱਕੋ",
    "Rates": "ਦਰਾਂ",
    "Reports": "ਰਿਪੋਰਟਾਂ",
    "Routing": "ਰੂਟਿੰਗ",
    "SMS": "SMS",
    "Statistics": "ਅੰਕੜੇ",
    "Support": "ਸਪੋਰਟ",
    "TRFs & Claims": "TRFs ਅਤੇ ਦਾਅਵੇ",
    "TRFs Templates": "TRFs ਟੈਂਪਲੇਟਸ",
    "Trips": "ਯਾਤਰਾਵਾਂ",
    "Vehicle Expense": "ਵਾਹਨ ਦਾ ਖਰਚਾ",
    "Vehicle Inspection": "ਵਾਹਨ ਨਿਰੀਖਣ",
    "Zones": "ਜ਼ੋਨ",
    "back": "ਵਾਪਸ",
    "next": "ਅੱਗੇ",
    "previous": "ਪਿਛਲਾ",
    "upload": "ਅੱਪਲੋਡ ਕਰੋ",
    "export": "ਨਿਰਯਾਤ",
    "import": "ਆਯਾਤ ਕਰੋ",
    "refresh": "ਤਾਜ਼ਾ ਕਰੋ",
    "edit": "ਸੰਪਾਦਿਤ ਕਰੋ",
    "view": "ਦੇਖੋ",
    "loading": "ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "deselectAll": "ਸਭ ਨੂੰ ਅਣਚੁਣਿਆ ਕਰੋ",
    "more": "ਹੋਰ...",
    "clearFilters": "ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ",
    "clearFilter": "ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ",
    "clearAll": "ਸਭ ਸਾਫ਼ ਕਰੋ",
    "applyFilters": "ਫਿਲਟਰ ਲਾਗੂ ਕਰੋ",
    "applyFilter": "ਫਿਲਟਰ ਲਾਗੂ ਕਰੋ",
    "noData": "ਕੋਈ ਡਾਟਾ ਨਹੀਂ",
    "noResults": "ਕੋਈ ਨਤੀਜਾ ਨਹੀਂ",
    "ok": "OK",
    "filters": "ਫਿਲਟਰ",
    "Staging": "ਸਟੇਜਿੰਗ",
    "Assigned": "ਸਪੁਰਦ ਕੀਤਾ",

    "memberInfoHeader": "ਮੈਂਬਰ ਜਾਣਕਾਰੀ",
    "serviceInfoHeader": "ਸੇਵਾ ਜਾਣਕਾਰੀ",
    "dateTimeHeader": "ਮਿਤੀ ਅਤੇ ਸਮਾਂ",
    "pickupTimeLabel": "ਪਿਕਅੱਪ ਸਮਾਂ",
    "dropoffTimeLabel": "ਡ੍ਰੌਪਆਫ ਸਮਾਂ",
    "cityLabel": "ਸ਼ਹਿਰ",
    "stateLabel": "ਰਾਜ",
    "zipCodeLabel": "ਜ਼ਿਪ ਕੋਡ",
    "notesHeader": "ਨੋਟਸ",
    "attachmentsHeader": "ਅਟੈਚਮੈਂਟਸ",
    "paymentStatus": "ਭੁਗਤਾਨ ਸਥਿਤੀ",
    "assistedBy": "ਦੁਆਰਾ ਸਹਾਇਤਾ ਪ੍ਰਾਪਤ:",
    "insuranceId": "ਬੀਮਾ ID",
    "ipaNumber": "IPA ਨੰਬਰ",
    "passengerName": "ਯਾਤਰੀ ਦਾ ਨਾਮ",
    "cellPhone": "ਸੈੱਲ ਫੋਨ",
    "dob": "ਜਨਮ ਮਿਤੀ",
    "clientId": "ਗਾਹਕ ID",
    "forDriver": "ਡਰਾਈਵਰ ਲਈ",
    "actualMiles": "ਅਸਲ ਮੀਲ",
    "paymentMode": "ਭੁਗਤਾਨ ਵਿਧੀ",
    "deadMinutes": "ਡੈੱਡ ਮਿੰਟ",
    "tripMiles": "ਯਾਤਰਾ ਮੀਲ",
    "tripTime": "ਯਾਤਰਾ ਸਮਾਂ",
    "totalTripMiles": "ਕੁੱਲ ਯਾਤਰਾ ਮੀਲ",
    "totalTripTime": "ਕੁੱਲ ਯਾਤਰਾ ਸਮਾਂ",
    "totalTripMilesInclDeadMiles": "ਕੁੱਲ ਯਾਤਰਾ ਮੀਲ (ਡੈੱਡ ਮੀਲ ਸਮੇਤ)",
    "totalTripTimeInclDeadMinutes": "ਕੁੱਲ ਯਾਤਰਾ ਸਮਾਂ (ਡੈੱਡ ਮਿੰਟ ਸਮੇਤ)",
    "odometerEnd": "ਓਡੋਮੀਟਰ ਸਮਾਪਤ",
    "enRoute": "ਰਸਤੇ ਵਿੱਚ",
    "readySince": "ਤਿਆਰ ਜਦੋਂ ਤੋਂ:",
    "app": "ਐਪ",
    "availabilityDays": "ਉਪਲਬਧਤਾ ਦੇ ਦਿਨ",
    "joiningDate": "ਸ਼ਾਮਲ ਹੋਣ ਦੀ ਮਿਤੀ",
    "sunday": "ਐਤਵਾਰ",
    "sun": "ਐਤਵਾਰ",
    "monday": "ਸੋਮਵਾਰ",
    "mon": "ਸੋਮਵਾਰ",
    "tuesday": "ਮੰਗਲਵਾਰ",
    "tue": "ਮੰਗਲਵਾਰ",
    "wednesday": "ਬੁੱਧਵਾਰ",
    "wed": "ਬੁੱਧਵਾਰ",
    "thursday": "ਵੀਰਵਾਰ",
    "thu": "ਵੀਰਵਾਰ",
    "friday": "ਸ਼ੁੱਕਰਵਾਰ",
    "fri": "ਸ਼ੁੱਕਰਵਾਰ",
    "saturday": "ਸ਼ਨੀਵਾਰ",
    "sat": "ਸ਼ਨੀਵਾਰ",
    "dayMon": "ਸੋਮ",
    "dayTue": "ਮੰਗਲ",
    "dayWed": "ਬੁੱਧ",
    "dayThu": "ਵੀਰ",
    "dayFri": "ਸ਼ੁੱਕਰ",
    "daySat": "ਸ਼ਨੀ",
    "daySun": "ਐਤ",
    "addressPicker": "ਪਤਾ ਚੋਣਕਾਰ",
    "smsConfiguration": "ਐਸਐਮਐਸ ਸੰਰਚਨਾ",
    "confirmationTemplate": "ਪੁਸ਼ਟੀ ਟੈਮਪਲੇਟ",
    "default": "ਡਿਫੌਲਟ",
    "boldage": "Boldage"
};
